import { useCallback, useEffect, useMemo, useState } from 'react';
import './App.css';

const API_BASE = process.env.REACT_APP_API_BASE
  || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:8080/api'
    : '/api');

const LANGS = ['de', 'en', 'ru'];

const DICT = {
  de: {
    navSearch: 'Suche',
    navWipes: 'Wipes',
    navCompare: 'Vergleich',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Finde den perfekten Rust-Server.',
    heroCopy: 'Suche nach Wipe, Teamlimit, Rates, Region, Ping, Modded/Vanilla, Aktivität und Datenqualität.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Suchen',
    all: 'Alle',
    servers: 'Server',
    playersOnline: 'Spieler online',
    justWiped: 'Gerade gewiped',
    verifiedServers: 'Starke Datenquellen',
    liveServers: 'Live-Server',
    topServers: 'Top-Server',
    bestDuo: 'Beste Duo Server',
    bestVanilla: 'Beste Vanilla Server',
    upcomingWipes: 'Kommende Wipes',
    verified: 'Owner-verifiziert',
    officialTag: 'Steam-Tags',
    nameDetected: 'Aus Name erkannt',
    historyEstimated: 'Historisch geschätzt',
    uncertain: 'Unsicher',
    sourceA2s: 'A2S + Steam',
    sourceBorn: 'Steam Born-Tag',
    sourceEstimate: 'Geschätzt',
    source: 'Quelle',
    confidence: 'Sicherheit',
    quickFilters: 'Schnellfilter',
    advancedFilters: 'Erweiterte Filter',
    region: 'Region',
    type: 'Typ',
    team: 'Team',
    gather: 'Gather',
    wipe: 'Wipe',
    quality: 'Qualität',
    population: 'Population',
    sort: 'Ranking',
    lowPing: 'Niedriger Ping',
    highPop: 'Hohe Pop',
    noBp: 'Kein BP-Wipe',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Offiziell',
    community: 'Community',
    premium: 'Premium',
    players: 'Spieler',
    ping: 'Ping',
    nextWipe: 'Nächster Wipe',
    lastWipe: 'Letzter Wipe',
    map: 'Map',
    mapSize: 'Map Size',
    bpWipe: 'BP-Wipe',
    dataQuality: 'Datenqualität',
    connect: 'Beitreten',
    copyIp: 'IP kopieren',
    details: 'Details',
    compare: 'Vergleichen',
    alert: 'Alarm',
    favorite: 'Favorit',
    remove: 'Entfernen',
    empty: 'Keine passenden Server gefunden.',
    quietError: 'Daten werden gerade aktualisiert. Bitte gleich erneut versuchen.',
    profile: 'Serverprofil',
    overview: 'Überblick',
    history: 'Historie',
    rules: 'Regeln',
    fullName: 'Vollständiger Name',
    endpoint: 'IP und Port',
    status: 'Status',
    mode: 'Modus',
    ownerStatus: 'Owner-Status',
    notClaimed: 'Nicht geclaimt',
    snapshots: 'Spieler 24h',
    wipeHistory: 'Wipe-Historie',
    noHistory: 'Noch keine Historie vorhanden.',
    close: 'Schließen',
    compareServers: 'Server vergleichen',
    compareHint: 'Wähle 2 bis 4 Server aus.',
    createAlert: 'Alarm erstellen',
    alertCopy: 'Wir merken uns diesen Suchwunsch im Browser. Backend-Benachrichtigungen können später E-Mail, Discord oder Telegram senden.',
    saveAlert: 'Alarm speichern',
    savedAlert: 'Alarm gespeichert',
    copied: 'Kopiert',
    connectCopied: 'Connect-Befehl kopiert',
    recommended: 'Empfohlen',
    ranking: 'Rust Radar Score',
    noBpWipe: 'Kein BP-Wipe',
    yes: 'Ja',
    no: 'Nein',
    unknown: 'Unbekannt',
    online: 'Online',
    offline: 'Offline',
    today: 'Heute',
    tomorrow: 'Morgen',
    seoTitle: 'Beliebte Rust-Suchen',
    footerCopy: 'Jede Information bekommt eine Quelle. Jede Schätzung bekommt einen Confidence Score.',
    from: 'Von',
    to: 'Bis',
    playersRange: 'Spieler',
    maxPlayersRange: 'Slots',
    pingRange: 'Ping (ms)',
    gatherRange: 'Gather x',
    teamRange: 'Teamgröße',
    qualityRange: 'Qualität %',
    wipeAgeRange: 'Wipe-Alter (Min.)',
    nextWipeRange: 'Nächster Wipe (Std.)',
    mapSizeRange: 'Map Size',
    queue: 'Warteschlange',
    activePlayers: 'Aktive Spieler',
    updatedAgo: 'Aktualisiert',
    scoreBreakdown: 'Score-Erklärung',
    scoreWipe: 'Wipe-Frische',
    scorePopulation: 'Population',
    scoreQuality: 'Datenqualität',
    scorePing: 'Ping',
    scoreStatus: 'Status',
    scoreRisk: 'Risiko',
    freshWipe: 'Frischer Wipe',
    stablePop: 'Stabile Pop',
    strongData: 'Daten stark',
    bpUnclear: 'BP-Wipe unsicher',
    queueDetected: 'Queue erkannt',
    dataWarning: 'Datenwarnung',
    fakeRiskLow: 'Fake-Pop-Risiko niedrig',
    fakeRiskMedium: 'Ungewöhnliche Player-Zahl',
    fakeRiskHigh: 'Player-Zahl über Slots prüfen',
    allFilters: 'Alle Filter',
    hideFilters: 'Filter ausblenden',
    resetFilters: 'Filter zurücksetzen',
    emptyFiltered: 'Aktuell keine passenden Server im aktiven Filter.',
    showWorldwide: 'Weltweit anzeigen',
    wipeUnder10: '0-10 Minuten',
    wipe10to30: '10-30 Minuten',
    wipe30to60: '30-60 Minuten',
    wipedToday: 'Heute gewiped',
    wipeHubCopy: 'Frische Wipes nach Alter, Aktivität und Datenqualität sortiert.',
    landingCopy: 'Diese Landingpage nutzt echte Live-Daten und setzt passende Filter automatisch.',
    compareSelected: 'Server ausgewählt',
    clear: 'Leeren',
    openCompare: 'Vergleichen',
    sourceDetails: 'Quellen-Details',
    ownerVerifiedOnly: 'Nur echte Owner-Claims werden als verifiziert markiert.',
    loginSteam: 'Mit Steam einloggen',
    logout: 'Ausloggen',
    account: 'Account',
    admin: 'Admin',
    adminPanel: 'Sponsor-Steuerung',
    adminLogin: 'Admin-Login',
    adminPassword: 'Admin-Passwort',
    login: 'Einloggen',
    signedInAs: 'Eingeloggt als',
    favorites: 'Favoriten',
    noFavorites: 'Noch keine Favoriten gespeichert.',
    sponsorAdmin: 'Sponsoren verwalten',
    sponsorTitle: 'Sponsor-Titel',
    sponsorDescription: 'Beschreibung',
    sponsorImage: 'Bild-URL',
    sponsorTarget: 'Ziel-URL',
    sponsorPlacement: 'Platzierung',
    sponsorServerId: 'Server-ID optional',
    sponsorPriority: 'Priorität',
    sponsorActive: 'Aktiv',
    sponsorStarts: 'Start',
    sponsorEnds: 'Ende',
    saveSponsor: 'Sponsor speichern',
    newSponsor: 'Neuer Sponsor',
    deleteSponsor: 'Löschen',
    sponsorLive: 'Live-Sponsoren',
    sponsored: 'Gesponsert',
    sponsorCopy: 'Fair markierte Sponsorenplätze mit Startzeit, Endzeit und Priorität.',
    adminHint: 'Hier steuerst du, wer wann auf der Seite angezeigt wird.',
    steamLoginCopy: 'Steam-Login läuft über die offizielle Steam-OpenID-Seite. Rust Radar sieht keine Steam-Passwörter.',
    loginRequiredFavorite: 'Für Account-Favoriten bitte mit Steam einloggen.',
    favoriteSaved: 'Favorit gespeichert',
    favoriteRemoved: 'Favorit entfernt',
    manageSponsors: 'Sponsoren steuern',
    currentSponsors: 'Aktuelle Sponsoren',
  },
  en: {
    navSearch: 'Search',
    navWipes: 'Wipes',
    navCompare: 'Compare',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Find the perfect Rust server.',
    heroCopy: 'Search by wipe, team limit, rates, region, ping, modded/vanilla, activity and data quality.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Search',
    all: 'All',
    servers: 'Servers',
    playersOnline: 'Players online',
    justWiped: 'Just wiped',
    verifiedServers: 'Strong data sources',
    liveServers: 'Live servers',
    topServers: 'Top servers',
    bestDuo: 'Best duo servers',
    bestVanilla: 'Best vanilla servers',
    upcomingWipes: 'Upcoming wipes',
    verified: 'Owner verified',
    officialTag: 'Steam tags',
    nameDetected: 'Detected from name',
    historyEstimated: 'History estimate',
    uncertain: 'Uncertain',
    sourceA2s: 'A2S + Steam',
    sourceBorn: 'Steam born tag',
    sourceEstimate: 'Estimated',
    source: 'Source',
    confidence: 'Confidence',
    quickFilters: 'Quick filters',
    advancedFilters: 'Advanced filters',
    region: 'Region',
    type: 'Type',
    team: 'Team',
    gather: 'Gather',
    wipe: 'Wipe',
    quality: 'Quality',
    population: 'Population',
    sort: 'Ranking',
    lowPing: 'Low ping',
    highPop: 'High pop',
    noBp: 'No BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Players',
    ping: 'Ping',
    nextWipe: 'Next wipe',
    lastWipe: 'Last wipe',
    map: 'Map',
    mapSize: 'Map size',
    bpWipe: 'BP wipe',
    dataQuality: 'Data quality',
    connect: 'Connect',
    copyIp: 'Copy IP',
    details: 'Details',
    compare: 'Compare',
    alert: 'Alert',
    favorite: 'Favorite',
    remove: 'Remove',
    empty: 'No matching servers found.',
    quietError: 'Data is being refreshed. Please try again shortly.',
    profile: 'Server profile',
    overview: 'Overview',
    history: 'History',
    rules: 'Rules',
    fullName: 'Full name',
    endpoint: 'IP and port',
    status: 'Status',
    mode: 'Mode',
    ownerStatus: 'Owner status',
    notClaimed: 'Not claimed',
    snapshots: 'Players 24h',
    wipeHistory: 'Wipe history',
    noHistory: 'No history yet.',
    close: 'Close',
    compareServers: 'Compare servers',
    compareHint: 'Select 2 to 4 servers.',
    createAlert: 'Create alert',
    alertCopy: 'This search is stored in your browser. Backend notifications can later send email, Discord or Telegram.',
    saveAlert: 'Save alert',
    savedAlert: 'Alert saved',
    copied: 'Copied',
    connectCopied: 'Connect command copied',
    recommended: 'Recommended',
    ranking: 'Rust Radar score',
    noBpWipe: 'No BP wipe',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    online: 'Online',
    offline: 'Offline',
    today: 'Today',
    tomorrow: 'Tomorrow',
    seoTitle: 'Popular Rust searches',
    footerCopy: 'Every fact gets a source. Every estimate gets a confidence score.',
    from: 'From',
    to: 'To',
    playersRange: 'Players',
    maxPlayersRange: 'Slots',
    pingRange: 'Ping (ms)',
    gatherRange: 'Gather x',
    teamRange: 'Team size',
    qualityRange: 'Quality %',
    wipeAgeRange: 'Wipe age (min.)',
    nextWipeRange: 'Next wipe (h)',
    mapSizeRange: 'Map size',
    queue: 'Queue',
    activePlayers: 'Active players',
    updatedAgo: 'Updated',
    scoreBreakdown: 'Score breakdown',
    scoreWipe: 'Wipe freshness',
    scorePopulation: 'Population',
    scoreQuality: 'Data quality',
    scorePing: 'Ping',
    scoreStatus: 'Status',
    scoreRisk: 'Risk',
    freshWipe: 'Fresh wipe',
    stablePop: 'Stable pop',
    strongData: 'Strong data',
    bpUnclear: 'BP wipe unclear',
    queueDetected: 'Queue detected',
    dataWarning: 'Data warning',
    fakeRiskLow: 'Fake-pop risk low',
    fakeRiskMedium: 'Unusual player count',
    fakeRiskHigh: 'Player count above slots',
    allFilters: 'All filters',
    hideFilters: 'Hide filters',
    resetFilters: 'Reset filters',
    emptyFiltered: 'No servers match the active filter right now.',
    showWorldwide: 'Show worldwide',
    wipeUnder10: '0-10 minutes',
    wipe10to30: '10-30 minutes',
    wipe30to60: '30-60 minutes',
    wipedToday: 'Wiped today',
    wipeHubCopy: 'Fresh wipes sorted by age, activity and data quality.',
    landingCopy: 'This landing page uses live data and applies the matching filters automatically.',
    compareSelected: 'servers selected',
    clear: 'Clear',
    openCompare: 'Compare',
    sourceDetails: 'Source details',
    ownerVerifiedOnly: 'Only real owner claims are marked as verified.',
    loginSteam: 'Sign in with Steam',
    logout: 'Log out',
    account: 'Account',
    admin: 'Admin',
    adminPanel: 'Sponsor control',
    adminLogin: 'Admin login',
    adminPassword: 'Admin password',
    login: 'Log in',
    signedInAs: 'Signed in as',
    favorites: 'Favorites',
    noFavorites: 'No favorites saved yet.',
    sponsorAdmin: 'Manage sponsors',
    sponsorTitle: 'Sponsor title',
    sponsorDescription: 'Description',
    sponsorImage: 'Image URL',
    sponsorTarget: 'Target URL',
    sponsorPlacement: 'Placement',
    sponsorServerId: 'Server ID optional',
    sponsorPriority: 'Priority',
    sponsorActive: 'Active',
    sponsorStarts: 'Starts',
    sponsorEnds: 'Ends',
    saveSponsor: 'Save sponsor',
    newSponsor: 'New sponsor',
    deleteSponsor: 'Delete',
    sponsorLive: 'Live sponsors',
    sponsored: 'Sponsored',
    sponsorCopy: 'Clearly marked sponsor placements with start time, end time and priority.',
    adminHint: 'Control who appears on the site and when.',
    steamLoginCopy: 'Steam login uses the official Steam OpenID page. Rust Radar never sees Steam passwords.',
    loginRequiredFavorite: 'Sign in with Steam for account favorites.',
    favoriteSaved: 'Favorite saved',
    favoriteRemoved: 'Favorite removed',
    manageSponsors: 'Control sponsors',
    currentSponsors: 'Current sponsors',
  },
  ru: {
    navSearch: 'Поиск',
    navWipes: 'Вайпы',
    navCompare: 'Сравнение',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Найди идеальный Rust-сервер.',
    heroCopy: 'Поиск по вайпу, лимиту команды, рейтам, региону, пингу, модам, активности и качеству данных.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Искать',
    all: 'Все',
    servers: 'Серверы',
    playersOnline: 'Игроков онлайн',
    justWiped: 'Недавний вайп',
    verifiedServers: 'Сильные источники',
    liveServers: 'Live серверы',
    topServers: 'Топ серверы',
    bestDuo: 'Лучшие Duo',
    bestVanilla: 'Лучшие Vanilla',
    upcomingWipes: 'Скоро вайп',
    verified: 'Owner подтвержден',
    officialTag: 'Steam теги',
    nameDetected: 'Из названия',
    historyEstimated: 'Оценка по истории',
    uncertain: 'Неуверенно',
    sourceA2s: 'A2S + Steam',
    sourceBorn: 'Steam born тег',
    sourceEstimate: 'Оценка',
    source: 'Источник',
    confidence: 'Уверенность',
    quickFilters: 'Быстрые фильтры',
    advancedFilters: 'Фильтры',
    region: 'Регион',
    type: 'Тип',
    team: 'Команда',
    gather: 'Рейт',
    wipe: 'Вайп',
    quality: 'Качество',
    population: 'Онлайн',
    sort: 'Рейтинг',
    lowPing: 'Низкий пинг',
    highPop: 'Высокий онлайн',
    noBp: 'Без BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Игроки',
    ping: 'Пинг',
    nextWipe: 'Следующий вайп',
    lastWipe: 'Последний вайп',
    map: 'Карта',
    mapSize: 'Размер карты',
    bpWipe: 'BP вайп',
    dataQuality: 'Качество данных',
    connect: 'Подключиться',
    copyIp: 'Копировать IP',
    details: 'Детали',
    compare: 'Сравнить',
    alert: 'Оповещение',
    favorite: 'Избранное',
    remove: 'Удалить',
    empty: 'Подходящих серверов нет.',
    quietError: 'Данные обновляются. Попробуй еще раз чуть позже.',
    profile: 'Профиль сервера',
    overview: 'Обзор',
    history: 'История',
    rules: 'Правила',
    fullName: 'Полное название',
    endpoint: 'IP и порт',
    status: 'Статус',
    mode: 'Режим',
    ownerStatus: 'Owner статус',
    notClaimed: 'Не подтвержден',
    snapshots: 'Игроки 24ч',
    wipeHistory: 'История вайпов',
    noHistory: 'Истории пока нет.',
    close: 'Закрыть',
    compareServers: 'Сравнить серверы',
    compareHint: 'Выбери от 2 до 4 серверов.',
    createAlert: 'Создать оповещение',
    alertCopy: 'Этот поиск сохранится в браузере. Позже backend сможет отправлять email, Discord или Telegram.',
    saveAlert: 'Сохранить оповещение',
    savedAlert: 'Оповещение сохранено',
    copied: 'Скопировано',
    connectCopied: 'Connect команда скопирована',
    recommended: 'Рекомендуем',
    ranking: 'Rust Radar score',
    noBpWipe: 'Без вайпа чертежей',
    yes: 'Да',
    no: 'Нет',
    unknown: 'Неизвестно',
    online: 'Онлайн',
    offline: 'Оффлайн',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    seoTitle: 'Популярные поиски Rust',
    footerCopy: 'У каждой информации есть источник. У каждой оценки есть confidence score.',
    from: 'От',
    to: 'До',
    playersRange: 'Игроки',
    maxPlayersRange: 'Слоты',
    pingRange: 'Пинг (мс)',
    gatherRange: 'Рейт x',
    teamRange: 'Размер команды',
    qualityRange: 'Качество %',
    wipeAgeRange: 'Возраст вайпа (мин.)',
    nextWipeRange: 'Следующий вайп (ч)',
    mapSizeRange: 'Размер карты',
    queue: 'Очередь',
    activePlayers: 'Активные игроки',
    updatedAgo: 'Обновлено',
    scoreBreakdown: 'Разбор score',
    scoreWipe: 'Свежесть вайпа',
    scorePopulation: 'Онлайн',
    scoreQuality: 'Качество данных',
    scorePing: 'Пинг',
    scoreStatus: 'Статус',
    scoreRisk: 'Риск',
    freshWipe: 'Свежий вайп',
    stablePop: 'Стабильный онлайн',
    strongData: 'Сильные данные',
    bpUnclear: 'BP вайп неясен',
    queueDetected: 'Очередь найдена',
    dataWarning: 'Предупреждение',
    fakeRiskLow: 'Риск fake-pop низкий',
    fakeRiskMedium: 'Необычный онлайн',
    fakeRiskHigh: 'Онлайн выше слотов',
    allFilters: 'Все фильтры',
    hideFilters: 'Скрыть фильтры',
    resetFilters: 'Сбросить фильтры',
    emptyFiltered: 'Сейчас нет серверов под активный фильтр.',
    showWorldwide: 'Показать все регионы',
    wipeUnder10: '0-10 минут',
    wipe10to30: '10-30 минут',
    wipe30to60: '30-60 минут',
    wipedToday: 'Вайп сегодня',
    wipeHubCopy: 'Свежие вайпы по возрасту, активности и качеству данных.',
    landingCopy: 'Эта страница использует live-данные и автоматически применяет фильтры.',
    compareSelected: 'серверов выбрано',
    clear: 'Очистить',
    openCompare: 'Сравнить',
    sourceDetails: 'Детали источников',
    ownerVerifiedOnly: 'Только реальные owner claims отмечаются как подтвержденные.',
    loginSteam: 'Войти через Steam',
    logout: 'Выйти',
    account: 'Аккаунт',
    admin: 'Админ',
    adminPanel: 'Управление спонсорами',
    adminLogin: 'Админ вход',
    adminPassword: 'Админ пароль',
    login: 'Войти',
    signedInAs: 'Вошел как',
    favorites: 'Избранное',
    noFavorites: 'Избранных серверов пока нет.',
    sponsorAdmin: 'Управлять спонсорами',
    sponsorTitle: 'Название спонсора',
    sponsorDescription: 'Описание',
    sponsorImage: 'URL картинки',
    sponsorTarget: 'Целевой URL',
    sponsorPlacement: 'Место',
    sponsorServerId: 'Server ID optional',
    sponsorPriority: 'Приоритет',
    sponsorActive: 'Активно',
    sponsorStarts: 'Старт',
    sponsorEnds: 'Конец',
    saveSponsor: 'Сохранить спонсора',
    newSponsor: 'Новый спонсор',
    deleteSponsor: 'Удалить',
    sponsorLive: 'Live спонсоры',
    sponsored: 'Спонсор',
    sponsorCopy: 'Честно отмеченные спонсорские места со стартом, концом и приоритетом.',
    adminHint: 'Управляй кто и когда показывается на сайте.',
    steamLoginCopy: 'Steam вход идет через официальную Steam OpenID страницу. Rust Radar не видит пароли Steam.',
    loginRequiredFavorite: 'Войди через Steam для account favorites.',
    favoriteSaved: 'Избранное сохранено',
    favoriteRemoved: 'Избранное удалено',
    manageSponsors: 'Управлять спонсорами',
    currentSponsors: 'Текущие спонсоры',
  }
};

const UX_COPY = {
  de: {
    searchModeQuick: 'Schnell finden',
    searchModeFinder: 'Server-Finder',
    searchModePro: 'Profi-Filter',
    activeSearch: 'Aktive Suche',
    noActiveFilters: 'Noch keine Filter aktiv',
    activeSearchHint: 'Du suchst gerade nach',
    playstyleTitle: 'Wonach suchst du?',
    playstyleCopy: 'Ein Klick setzt automatisch passende Filter.',
    finderTitle: 'Server-Finder starten',
    finderCopy: 'Beantworte kurz 5 Fragen. Rust Radar baut daraus deine Suche.',
    finderStep: 'Schritt',
    finderResults: 'Passende Server',
    finderBack: 'Zurück',
    finderRestart: 'Neu starten',
    finderTeam: 'Wie spielst du?',
    finderGameplay: 'Was für Gameplay willst du?',
    finderWipe: 'Wann soll der Server gewiped sein?',
    finderPop: 'Wie voll soll er sein?',
    finderRegion: 'Region und Ping',
    any: 'Egal',
    smallGroup: 'Kleine Gruppe',
    clan: 'Clan',
    vanillaPlus: 'Vanilla+',
    training: 'Training',
    wipedNow: 'Gerade eben',
    thisWeek: 'Diese Woche',
    nextWipeSoon: 'Nächster Wipe bald',
    quietPop: 'Ruhig',
    mediumPop: 'Mittel',
    veryActive: 'Sehr aktiv',
    notFull: 'Nicht voll',
    preferLowPing: 'Niedriger Ping bevorzugt',
    presetFreshTitle: 'Fresh starten',
    presetFreshCopy: 'Frische Wipes mit genug Aktivität.',
    presetSmallTitle: 'Nicht gegen Clans',
    presetSmallCopy: 'Solo, Duo und Trio mit kleiner Teamgröße.',
    presetVanillaTitle: 'Vanilla ohne Stress',
    presetVanillaCopy: 'Klassisches Rust mit starken Daten.',
    presetFastTitle: 'Schneller Progress',
    presetFastCopy: '2x/3x, aktive Server und schnelle Action.',
    presetPveTitle: 'PvE / Anfänger',
    presetPveCopy: 'Entspannter Einstieg ohne Dauerstress.',
    presetClanTitle: 'High Pop Action',
    presetClanCopy: 'Viele Spieler, größere Teams, mehr Druck.',
    recommendedForYou: 'Wir empfehlen dir',
    bestChoice: 'Beste Wahl',
    freshestChoice: 'Frischester Wipe',
    strongestDataChoice: 'Beste Datenqualität',
    activeChoice: 'Aktivster Server',
    viewMode: 'Ansicht',
    viewRecommended: 'Empfohlen',
    viewCompact: 'Kompakt',
    viewExpert: 'Expert',
    matchForSearch: 'passend',
    whyMatches: 'Warum passend',
    proFilters: 'Weitere Filter anzeigen',
    quickFilterCountHint: 'Treffer',
    matchRegion: 'Region passt',
    matchTeam: 'Teamlimit passt',
    matchGather: 'Rate passt',
    matchMode: 'Modus passt',
    matchFresh: 'Frischer Wipe',
    matchBp: 'BP-Wipe passt',
    matchPing: 'Niedriger Ping',
    matchQuality: 'Datenqualität passt',
    matchPopulation: 'Population passt',
    matchRange: 'Wertebereich passt',
    mismatchUnverified: 'Teilweise geschätzt',
    tableServer: 'Server',
    tableFit: 'Match',
    tablePlayers: 'Spieler',
    tableWipe: 'Wipe',
    tableTeam: 'Team',
    tableRate: 'Rate',
    tablePing: 'Ping',
    tableQuality: 'Qualität',
    tableActions: 'Aktion'
  },
  en: {
    searchModeQuick: 'Quick find',
    searchModeFinder: 'Server finder',
    searchModePro: 'Pro filters',
    activeSearch: 'Active search',
    noActiveFilters: 'No active filters yet',
    activeSearchHint: 'You are looking for',
    playstyleTitle: 'What are you looking for?',
    playstyleCopy: 'One click applies the right filters.',
    finderTitle: 'Start server finder',
    finderCopy: 'Answer 5 quick questions. Rust Radar builds the search.',
    finderStep: 'Step',
    finderResults: 'Matching servers',
    finderBack: 'Back',
    finderRestart: 'Restart',
    finderTeam: 'How do you play?',
    finderGameplay: 'What gameplay do you want?',
    finderWipe: 'When should it have wiped?',
    finderPop: 'How populated should it be?',
    finderRegion: 'Region and ping',
    any: 'Any',
    smallGroup: 'Small group',
    clan: 'Clan',
    vanillaPlus: 'Vanilla+',
    training: 'Training',
    wipedNow: 'Just now',
    thisWeek: 'This week',
    nextWipeSoon: 'Next wipe soon',
    quietPop: 'Quiet',
    mediumPop: 'Medium',
    veryActive: 'Very active',
    notFull: 'Not full',
    preferLowPing: 'Prefer low ping',
    presetFreshTitle: 'Fresh start',
    presetFreshCopy: 'Fresh wipes with enough activity.',
    presetSmallTitle: 'Avoid clans',
    presetSmallCopy: 'Solo, duo and trio with small teams.',
    presetVanillaTitle: 'Vanilla focus',
    presetVanillaCopy: 'Classic Rust with strong data.',
    presetFastTitle: 'Fast progress',
    presetFastCopy: '2x/3x, active servers and fast action.',
    presetPveTitle: 'PvE / beginner',
    presetPveCopy: 'A calmer start without constant pressure.',
    presetClanTitle: 'High pop action',
    presetClanCopy: 'More players, larger teams, more pressure.',
    recommendedForYou: 'Recommended for you',
    bestChoice: 'Best choice',
    freshestChoice: 'Freshest wipe',
    strongestDataChoice: 'Best data quality',
    activeChoice: 'Most active',
    viewMode: 'View',
    viewRecommended: 'Recommended',
    viewCompact: 'Compact',
    viewExpert: 'Expert',
    matchForSearch: 'match',
    whyMatches: 'Why it matches',
    proFilters: 'Show more filters',
    quickFilterCountHint: 'matches',
    matchRegion: 'Region matches',
    matchTeam: 'Team limit matches',
    matchGather: 'Rate matches',
    matchMode: 'Mode matches',
    matchFresh: 'Fresh wipe',
    matchBp: 'BP wipe matches',
    matchPing: 'Low ping',
    matchQuality: 'Data quality matches',
    matchPopulation: 'Population matches',
    matchRange: 'Range matches',
    mismatchUnverified: 'Partly estimated',
    tableServer: 'Server',
    tableFit: 'Match',
    tablePlayers: 'Players',
    tableWipe: 'Wipe',
    tableTeam: 'Team',
    tableRate: 'Rate',
    tablePing: 'Ping',
    tableQuality: 'Quality',
    tableActions: 'Action'
  },
  ru: {
    searchModeQuick: 'Быстрый поиск',
    searchModeFinder: 'Server Finder',
    searchModePro: 'Pro фильтры',
    activeSearch: 'Активный поиск',
    noActiveFilters: 'Фильтры еще не выбраны',
    activeSearchHint: 'Ты ищешь',
    playstyleTitle: 'Что ты ищешь?',
    playstyleCopy: 'Один клик применяет нужные фильтры.',
    finderTitle: 'Запустить Server Finder',
    finderCopy: 'Ответь на 5 вопросов. Rust Radar соберет поиск.',
    finderStep: 'Шаг',
    finderResults: 'Подходящие серверы',
    finderBack: 'Назад',
    finderRestart: 'Сначала',
    finderTeam: 'Как ты играешь?',
    finderGameplay: 'Какой геймплей нужен?',
    finderWipe: 'Когда должен быть вайп?',
    finderPop: 'Какой онлайн нужен?',
    finderRegion: 'Регион и пинг',
    any: 'Не важно',
    smallGroup: 'Малая группа',
    clan: 'Клан',
    vanillaPlus: 'Vanilla+',
    training: 'Training',
    wipedNow: 'Только что',
    thisWeek: 'На этой неделе',
    nextWipeSoon: 'Скоро вайп',
    quietPop: 'Спокойно',
    mediumPop: 'Средне',
    veryActive: 'Очень активно',
    notFull: 'Не полный',
    preferLowPing: 'Низкий пинг',
    presetFreshTitle: 'Свежий старт',
    presetFreshCopy: 'Свежие вайпы с активностью.',
    presetSmallTitle: 'Без кланов',
    presetSmallCopy: 'Solo, duo и trio для малых групп.',
    presetVanillaTitle: 'Vanilla',
    presetVanillaCopy: 'Классический Rust с сильными данными.',
    presetFastTitle: 'Быстрый прогресс',
    presetFastCopy: '2x/3x, активные серверы и action.',
    presetPveTitle: 'PvE / новичок',
    presetPveCopy: 'Спокойный старт без давления.',
    presetClanTitle: 'High pop action',
    presetClanCopy: 'Много игроков, большие команды.',
    recommendedForYou: 'Рекомендуем',
    bestChoice: 'Лучший выбор',
    freshestChoice: 'Самый свежий вайп',
    strongestDataChoice: 'Лучшее качество данных',
    activeChoice: 'Самый активный',
    viewMode: 'Вид',
    viewRecommended: 'Рекомендуемый',
    viewCompact: 'Компактно',
    viewExpert: 'Expert',
    matchForSearch: 'match',
    whyMatches: 'Почему подходит',
    proFilters: 'Показать больше фильтров',
    quickFilterCountHint: 'совпадений',
    matchRegion: 'Регион подходит',
    matchTeam: 'Команда подходит',
    matchGather: 'Рейт подходит',
    matchMode: 'Режим подходит',
    matchFresh: 'Свежий вайп',
    matchBp: 'BP подходит',
    matchPing: 'Низкий пинг',
    matchQuality: 'Качество подходит',
    matchPopulation: 'Онлайн подходит',
    matchRange: 'Диапазон подходит',
    mismatchUnverified: 'Частично оценка',
    tableServer: 'Сервер',
    tableFit: 'Match',
    tablePlayers: 'Игроки',
    tableWipe: 'Вайп',
    tableTeam: 'Команда',
    tableRate: 'Рейт',
    tablePing: 'Пинг',
    tableQuality: 'Качество',
    tableActions: 'Действие'
  }
};

const finderQuestions = [
  {
    id: 'team',
    titleKey: 'finderTeam',
    choices: [
      { id: 'solo', label: 'Solo', patch: { group: 'solo', teamMin: '1', teamMax: '1' } },
      { id: 'duo', label: 'Duo', patch: { group: 'duo', teamMin: '2', teamMax: '2' } },
      { id: 'trio', label: 'Trio', patch: { group: 'trio', teamMin: '3', teamMax: '3' } },
      { id: 'small', labelKey: 'smallGroup', patch: { group: 'all', teamMax: '4' } },
      { id: 'clan', labelKey: 'clan', patch: { group: 'no-limit', teamMin: '6', teamMax: '' } },
      { id: 'any', labelKey: 'any', patch: { group: 'all', teamMin: '', teamMax: '' } }
    ]
  },
  {
    id: 'gameplay',
    titleKey: 'finderGameplay',
    choices: [
      { id: 'vanilla', labelKey: 'vanilla', patch: { mode: 'vanilla', gather: '1x', gatherMin: '', gatherMax: '' } },
      { id: 'vanilla-plus', labelKey: 'vanillaPlus', patch: { mode: 'vanilla', gatherMin: '1', gatherMax: '1.5' } },
      { id: '2x', label: '2x / 3x', patch: { mode: 'modded', gatherMin: '2', gatherMax: '3' } },
      { id: 'modded', labelKey: 'modded', patch: { mode: 'modded' } },
      { id: 'pve', label: 'PvE', patch: { mode: 'pve' } },
      { id: 'any', labelKey: 'any', patch: { mode: 'all', gather: 'all', gatherMin: '', gatherMax: '' } }
    ]
  },
  {
    id: 'wipe',
    titleKey: 'finderWipe',
    choices: [
      { id: 'now', labelKey: 'wipedNow', patch: { sort: 'wipe', wipeAgeMin: '', wipeAgeMax: '60' }, local: { justWiped: true } },
      { id: 'today', labelKey: 'wipedToday', patch: { sort: 'wipe', wipeAgeMax: '1440' }, local: { justWiped: true } },
      { id: 'week', labelKey: 'thisWeek', patch: { wipeAgeMax: '10080' }, local: {} },
      { id: 'soon', labelKey: 'nextWipeSoon', patch: { nextWipeMin: '', nextWipeMax: '24', sort: 'wipe' }, local: {} },
      { id: 'monthly', labelKey: 'monthly', patch: { wipe: 'monthly' }, local: {} },
      { id: 'any', labelKey: 'any', patch: { wipe: 'all', wipeAgeMin: '', wipeAgeMax: '', nextWipeMin: '', nextWipeMax: '' }, local: {} }
    ]
  },
  {
    id: 'population',
    titleKey: 'finderPop',
    choices: [
      { id: 'quiet', labelKey: 'quietPop', patch: { population: 'low', playersMin: '1', playersMax: '29' } },
      { id: 'medium', labelKey: 'mediumPop', patch: { population: 'medium', playersMin: '30', playersMax: '99' } },
      { id: 'active', labelKey: 'veryActive', patch: { population: 'high', playersMin: '100', playersMax: '' } },
      { id: 'not-full', labelKey: 'notFull', patch: { playersMin: '20', playersMax: '', maxPlayersMin: '80' } },
      { id: 'any', labelKey: 'any', patch: { population: 'all', playersMin: '', playersMax: '', maxPlayersMin: '' } }
    ]
  },
  {
    id: 'region',
    titleKey: 'finderRegion',
    choices: [
      { id: 'eu', label: 'EU', patch: { region: 'EU' } },
      { id: 'de', label: 'DE', patch: { region: 'EU', query: 'deutsch german' } },
      { id: 'ru', label: 'RU', patch: { region: 'RU' } },
      { id: 'us', label: 'US', patch: { region: 'US' } },
      { id: 'low-ping', labelKey: 'preferLowPing', patch: { lowPing: true, pingMax: '80' } },
      { id: 'any', labelKey: 'any', patch: { region: 'all', lowPing: false, pingMax: '' } }
    ]
  }
];

const playstylePresets = [
  { id: 'fresh', titleKey: 'presetFreshTitle', copyKey: 'presetFreshCopy', patch: { sort: 'wipe', playersMin: '20', qualityMin: '60' }, local: { justWiped: true }, tags: ['Wipe < 1h', '20+ Spieler'] },
  { id: 'small', titleKey: 'presetSmallTitle', copyKey: 'presetSmallCopy', patch: { group: 'all', teamMax: '3', playersMin: '20' }, local: {}, tags: ['Solo/Duo/Trio', 'Max 3'] },
  { id: 'vanilla', titleKey: 'presetVanillaTitle', copyKey: 'presetVanillaCopy', patch: { mode: 'vanilla', gather: '1x', qualityMin: '70' }, local: {}, tags: ['Vanilla', '1x'] },
  { id: 'fast', titleKey: 'presetFastTitle', copyKey: 'presetFastCopy', patch: { mode: 'modded', gatherMin: '2', gatherMax: '3', playersMin: '40' }, local: {}, tags: ['2x/3x', 'Action'] },
  { id: 'pve', titleKey: 'presetPveTitle', copyKey: 'presetPveCopy', patch: { mode: 'pve', playersMin: '1' }, local: {}, tags: ['PvE', 'Starter'] },
  { id: 'clan', titleKey: 'presetClanTitle', copyKey: 'presetClanCopy', patch: { population: 'high', playersMin: '100', teamMin: '5', sort: 'players' }, local: {}, tags: ['High Pop', 'Clan'] }
];

const defaultFilters = {
  query: '',
  mode: 'all',
  region: 'all',
  gather: 'all',
  group: 'all',
  wipe: 'all',
  minPlayers: 0,
  playersMin: '',
  playersMax: '',
  maxPlayersMin: '',
  maxPlayersMax: '',
  pingMin: '',
  pingMax: '',
  gatherMin: '',
  gatherMax: '',
  teamMin: '',
  teamMax: '',
  qualityMin: '',
  qualityMax: '',
  wipeAgeMin: '',
  wipeAgeMax: '',
  nextWipeMin: '',
  nextWipeMax: '',
  mapSizeMin: '',
  mapSizeMax: '',
  sort: 'confidence',
  onlineOnly: true,
  quality: 'all',
  population: 'all',
  bp: 'all',
  lowPing: false
};

const quickFilters = [
  { id: 'just-wiped', labelKey: 'justWiped', patch: { wipe: 'all', sort: 'wipe' }, local: { justWiped: true } },
  { id: 'eu', label: 'EU', patch: { region: 'EU' } },
  { id: 'solo', label: 'Solo', patch: { group: 'solo' } },
  { id: 'duo', label: 'Duo', patch: { group: 'duo' } },
  { id: 'trio', label: 'Trio', patch: { group: 'trio' } },
  { id: '2x', label: '2x', patch: { gather: '2x' } },
  { id: 'vanilla', labelKey: 'vanilla', patch: { mode: 'vanilla' } },
  { id: 'monthly', labelKey: 'monthly', patch: { wipe: 'monthly' } },
  { id: 'no-bp', labelKey: 'noBp', patch: { bp: 'no' } },
  { id: 'pve', label: 'PvE', patch: { mode: 'pve' } },
  { id: 'low-ping', labelKey: 'lowPing', patch: { lowPing: true } }
];

const landingPages = [
  { path: '/de/wipes', label: 'Rust Server gerade gewiped', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/en/just-wiped-rust-servers', label: 'Just Wiped Rust Servers', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/ru/wipes', label: 'Недавние Rust вайпы', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/de/rust-duo-server', label: 'Beste Rust Duo Server', patch: { group: 'duo' } },
  { path: '/en/rust-duo-servers', label: 'Best Rust Duo Servers', patch: { group: 'duo' } },
  { path: '/ru/rust-duo-серверы', label: 'Rust Duo серверы', patch: { group: 'duo' } },
  { path: '/de/rust-2x-server', label: 'Rust 2x Server', patch: { gather: '2x' } },
  { path: '/de/deutsche-rust-server', label: 'Deutsche Rust Server', patch: { region: 'EU', query: 'german deutsch' } },
  { path: '/en/rust-vanilla-servers', label: 'Rust Vanilla Servers', patch: { mode: 'vanilla' } },
  { path: '/en/rust-no-bp-wipe-servers', label: 'No BP Wipe Servers', patch: { bp: 'no' } }
];

function hasValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== '';
}

function addRangeParam(params, key, value) {
  if (hasValue(value)) {
    params.set(key, String(value).trim());
  }
}

function isQuickFilterActive(chip, filters, localFlags) {
  const patchActive = Object.entries(chip.patch || {}).every(([key, value]) => filters[key] === value);
  const localActive = Object.entries(chip.local || {}).every(([key, value]) => localFlags[key] === value);
  return patchActive && localActive;
}

function emptySponsorDraft() {
  return {
    id: null,
    title: '',
    description: '',
    imageUrl: '',
    targetUrl: '',
    placement: 'home_top',
    serverId: '',
    active: true,
    priority: 0,
    startsAt: '',
    endsAt: ''
  };
}

function draftFromSponsor(sponsor) {
  return {
    id: sponsor.id,
    title: sponsor.title || '',
    description: sponsor.description || '',
    imageUrl: sponsor.imageUrl || '',
    targetUrl: sponsor.targetUrl || '',
    placement: sponsor.placement || 'home_top',
    serverId: sponsor.serverId || '',
    active: sponsor.active !== false,
    priority: sponsor.priority || 0,
    startsAt: toDateTimeLocal(sponsor.startsAt),
    endsAt: toDateTimeLocal(sponsor.endsAt)
  };
}

function sponsorPayload(draft) {
  return {
    title: draft.title,
    description: draft.description,
    imageUrl: draft.imageUrl,
    targetUrl: draft.targetUrl,
    placement: draft.placement || 'home_top',
    serverId: hasValue(draft.serverId) ? Number(draft.serverId) : null,
    active: draft.active,
    priority: hasValue(draft.priority) ? Number(draft.priority) : 0,
    startsAt: draft.startsAt ? new Date(draft.startsAt).toISOString() : null,
    endsAt: draft.endsAt ? new Date(draft.endsAt).toISOString() : null
  };
}

function toDateTimeLocal(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('rustRadarLang') || detectLanguage());
  const [smartQuery, setSmartQuery] = useState('');
  const [filters, setFilters] = useState(defaultFilters);
  const [localFlags, setLocalFlags] = useState({});
  const [servers, setServers] = useState([]);
  const [stats, setStats] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [softError, setSoftError] = useState(false);
  const [selected, setSelected] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [wipes, setWipes] = useState([]);
  const [toast, setToast] = useState('');
  const [compareIds, setCompareIds] = useState(() => readJson('rustRadarCompare', []));
  const [favoriteIds, setFavoriteIds] = useState(() => readJson('rustRadarFavorites', []));
  const [alertOpen, setAlertOpen] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [searchMode, setSearchMode] = useState('quick');
  const [finderStep, setFinderStep] = useState(0);
  const [finderAnswers, setFinderAnswers] = useState({});
  const [resultView, setResultView] = useState('recommended');
  const [currentUser, setCurrentUser] = useState({ authenticated: false, admin: false, adminVisible: false });
  const [accountFavorites, setAccountFavorites] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [adminSponsors, setAdminSponsors] = useState([]);
  const [adminPassword, setAdminPassword] = useState('');
  const [sponsorDraft, setSponsorDraft] = useState(emptySponsorDraft());
  const [routePath, setRoutePath] = useState(window.location.pathname);

  const t = DICT[lang] || DICT.de;
  const ux = UX_COPY[lang] || UX_COPY.de;
  const activeLanding = landingPages.find((pageItem) => pageItem.path === routePath);

  useEffect(() => {
    localStorage.setItem('rustRadarLang', lang);
  }, [lang]);

  useEffect(() => {
    const match = landingPages.find((pageItem) => pageItem.path === window.location.pathname);
    if (match) {
      setFilters((current) => ({ ...current, ...match.patch }));
      setLocalFlags(match.local || {});
    }
  }, []);

  useEffect(() => {
    const onRoute = () => setRoutePath(window.location.pathname);
    window.addEventListener('popstate', onRoute);
    return () => window.removeEventListener('popstate', onRoute);
  }, []);

  useEffect(() => {
    localStorage.setItem('rustRadarCompare', JSON.stringify(compareIds));
  }, [compareIds]);

  useEffect(() => {
    localStorage.setItem('rustRadarFavorites', JSON.stringify(favoriteIds));
  }, [favoriteIds]);

  const request = useCallback(async (path, options = {}) => {
    const response = await fetch(`${API_BASE}${path}`, {
      credentials: 'include',
      ...options,
      headers: {
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {})
      }
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `HTTP ${response.status}`);
    }
    if (response.status === 204) {
      return null;
    }
    return response.json();
  }, []);

  const queryString = useMemo(() => {
    const params = new URLSearchParams({
      page: String(page),
      size: '200',
      mode: filters.mode,
      region: filters.region,
      gather: filters.gather,
      group: filters.group,
      wipe: filters.wipe,
      sort: filters.sort === 'radar' ? 'confidence' : filters.sort,
      onlineOnly: String(filters.onlineOnly)
    });
    if (filters.query.trim()) params.set('query', filters.query.trim());
    if (filters.bp !== 'all') params.set('bpWipe', filters.bp);
    if (Number(filters.minPlayers) > 0) params.set('minPlayers', String(filters.minPlayers));
    if (!hasValue(filters.playersMin) && Number(filters.minPlayers) > 0) {
      params.set('playersMin', String(filters.minPlayers));
    }
    addRangeParam(params, 'playersMin', filters.playersMin);
    addRangeParam(params, 'playersMax', filters.playersMax);
    addRangeParam(params, 'maxPlayersMin', filters.maxPlayersMin);
    addRangeParam(params, 'maxPlayersMax', filters.maxPlayersMax);
    addRangeParam(params, 'pingMin', filters.pingMin);
    addRangeParam(params, 'pingMax', filters.pingMax);
    addRangeParam(params, 'gatherMin', filters.gatherMin);
    addRangeParam(params, 'gatherMax', filters.gatherMax);
    addRangeParam(params, 'teamMin', filters.teamMin);
    addRangeParam(params, 'teamMax', filters.teamMax);
    addRangeParam(params, 'qualityMin', filters.qualityMin);
    addRangeParam(params, 'qualityMax', filters.qualityMax);
    addRangeParam(params, 'wipeAgeMinMinutes', filters.wipeAgeMin);
    addRangeParam(params, 'wipeAgeMaxMinutes', filters.wipeAgeMax);
    addRangeParam(params, 'nextWipeMinHours', filters.nextWipeMin);
    addRangeParam(params, 'nextWipeMaxHours', filters.nextWipeMax);
    addRangeParam(params, 'mapSizeMin', filters.mapSizeMin);
    addRangeParam(params, 'mapSizeMax', filters.mapSizeMax);
    return params.toString();
  }, [filters, page]);

  const loadServers = useCallback(async () => {
    try {
      const data = await request(`/servers?${queryString}`);
      setServers(data.items || []);
      setTotal(data.total || 0);
      setSoftError(false);
    } catch {
      setSoftError(true);
      setServers([]);
      setTotal(0);
    }
  }, [queryString, request]);

  const loadStats = useCallback(async () => {
    try {
      setStats(await request('/stats'));
    } catch {
      setStats(null);
    }
  }, [request]);

  const loadMe = useCallback(async () => {
    try {
      const me = await request('/auth/me');
      setCurrentUser(me || { authenticated: false, admin: false, adminVisible: false });
    } catch {
      setCurrentUser({ authenticated: false, admin: false, adminVisible: false });
    }
  }, [request]);

  const loadSponsors = useCallback(async () => {
    try {
      setSponsors(await request('/sponsors?placement=home_top'));
    } catch {
      setSponsors([]);
    }
  }, [request]);

  const loadAccountFavorites = useCallback(async () => {
    if (!currentUser.authenticated || currentUser.admin) {
      setAccountFavorites([]);
      return;
    }
    try {
      setAccountFavorites((await request('/me/favorites')).map((server) => enrichServer(server)));
    } catch {
      setAccountFavorites([]);
    }
  }, [currentUser.authenticated, currentUser.admin, request]);

  const loadAdminSponsors = useCallback(async () => {
    if (!currentUser.admin) {
      setAdminSponsors([]);
      return;
    }
    try {
      setAdminSponsors(await request('/admin/sponsors'));
    } catch {
      setAdminSponsors([]);
    }
  }, [currentUser.admin, request]);

  useEffect(() => {
    loadServers();
    const timer = window.setInterval(loadServers, 15000);
    return () => window.clearInterval(timer);
  }, [loadServers]);

  useEffect(() => {
    loadStats();
    const timer = window.setInterval(loadStats, 30000);
    return () => window.clearInterval(timer);
  }, [loadStats]);

  useEffect(() => {
    loadMe();
    loadSponsors();
  }, [loadMe, loadSponsors]);

  useEffect(() => {
    loadAccountFavorites();
    loadAdminSponsors();
  }, [loadAccountFavorites, loadAdminSponsors]);

  const baseServers = useMemo(() => servers.map((server) => enrichServer(server)), [servers]);

  const enrichedServers = useMemo(() => {
    return baseServers
      .map((server) => applyMatchContext(server, filters, localFlags))
      .filter((server) => applyLocalFilters(server, filters, localFlags))
      .sort((a, b) => sortLocal(a, b, filters.sort));
  }, [baseServers, filters, localFlags]);

  const activeChips = useMemo(() => buildActiveChips(filters, localFlags, smartQuery, t, ux), [filters, localFlags, smartQuery, t, ux]);
  const quickFilterCounts = useMemo(() => buildQuickFilterCounts(baseServers), [baseServers]);
  const recommendations = useMemo(() => buildRecommendations(enrichedServers), [enrichedServers]);

  const heroStats = useMemo(() => {
    const onlinePlayers = enrichedServers.reduce((sum, server) => sum + displayPopulation(server).active, 0);
    const justWiped = enrichedServers.filter((server) => server.isJustWiped).length;
    const verified = enrichedServers.filter((server) => hasStrongSource(server)).length;
    const updatedAt = enrichedServers
      .map((server) => dateValue(server.lastChecked || server.lastSuccessfulQuery || server.lastSeen))
      .filter(Boolean)
      .sort((a, b) => b - a)[0];
    return {
      totalServers: stats?.totalServers ?? total,
      onlinePlayers,
      justWiped,
      verified,
      updatedAt
    };
  }, [enrichedServers, stats, total]);

  const sections = useMemo(() => {
    const top = [...enrichedServers].sort((a, b) => b.radarScore - a.radarScore).slice(0, 6);
    const just = enrichedServers.filter((server) => server.isJustWiped).slice(0, 6);
    const duo = enrichedServers.filter((server) => server.groupLimitDetected === 'duo').slice(0, 6);
    const vanilla = enrichedServers.filter((server) => !server.moddedDetected).slice(0, 6);
    const upcoming = [...enrichedServers]
      .filter((server) => server.nextWipeEstimated)
      .sort((a, b) => new Date(a.nextWipeEstimated) - new Date(b.nextWipeEstimated))
      .slice(0, 6);
    return { top, just, duo, vanilla, upcoming };
  }, [enrichedServers]);

  const wipeBuckets = useMemo(() => buildWipeBuckets(enrichedServers), [enrichedServers]);

  const compareServers = useMemo(() => {
    return compareIds.map((id) => enrichedServers.find((server) => server.id === id)).filter(Boolean);
  }, [compareIds, enrichedServers]);

  const clearCompare = () => setCompareIds([]);
  const effectiveFavoriteIds = currentUser.authenticated && !currentUser.admin
    ? accountFavorites.map((server) => server.id)
    : favoriteIds;

  const updateFilter = (key, value) => {
    setFilters((current) => ({ ...current, [key]: value }));
    setLocalFlags((current) => key === 'sort' ? current : { ...current, justWiped: false });
    setPage(0);
  };

  const resetFilters = () => {
    setFilters(defaultFilters);
    setLocalFlags({});
    setSmartQuery('');
    setFinderAnswers({});
    setFinderStep(0);
    setPage(0);
  };

  const submitSmartSearch = (event) => {
    event.preventDefault();
    const parsed = parseSmartSearch(smartQuery);
    setFilters((current) => ({ ...current, ...parsed.filters, query: parsed.query }));
    setLocalFlags(parsed.local);
    setPage(0);
  };

  const applyQuickFilter = (chip) => {
    const active = isQuickFilterActive(chip, filters, localFlags);
    setFilters((current) => {
      if (!active) {
        return { ...current, ...chip.patch };
      }
      const next = { ...current };
      Object.keys(chip.patch || {}).forEach((key) => {
        next[key] = defaultFilters[key];
      });
      return next;
    });
    setLocalFlags((current) => {
      const next = active ? { ...current } : { ...current, ...(chip.local || {}) };
      if (active) {
        Object.keys(chip.local || {}).forEach((key) => {
          delete next[key];
        });
      }
      return next;
    });
    setPage(0);
  };

  const applyPreset = (preset) => {
    setSearchMode('quick');
    setFilters({ ...defaultFilters, ...preset.patch });
    setLocalFlags(preset.local || {});
    setFinderAnswers({});
    setFinderStep(0);
    setPage(0);
  };

  const applyFinderChoice = (question, choice) => {
    setFinderAnswers((current) => ({ ...current, [question.id]: choice.id }));
    setFilters((current) => ({ ...current, ...choice.patch }));
    setLocalFlags((current) => {
      const next = { ...current, ...(choice.local || {}) };
      if (question.id === 'wipe' && !choice.local?.justWiped) {
        delete next.justWiped;
      }
      return next;
    });
    setPage(0);
    setFinderStep((current) => Math.min(finderQuestions.length - 1, current + 1));
  };

  const removeActiveChip = (chip) => {
    if (chip.kind === 'query') {
      setSmartQuery('');
      setFilters((current) => ({ ...current, query: '' }));
    }
    if (chip.kind === 'local') {
      setLocalFlags((current) => {
        const next = { ...current };
        delete next[chip.key];
        return next;
      });
    }
    if (chip.kind === 'filter') {
      setFilters((current) => ({ ...current, [chip.key]: defaultFilters[chip.key] }));
    }
    if (chip.kind === 'range') {
      setFilters((current) => {
        const next = { ...current };
        chip.keys.forEach((key) => {
          next[key] = defaultFilters[key];
        });
        return next;
      });
    }
    setPage(0);
  };

  const openDetails = async (server) => {
    try {
      const [profile, history, wipeHistory] = await Promise.all([
        request(`/servers/${server.id}`),
        request(`/servers/${server.id}/snapshots`),
        request(`/servers/${server.id}/wipes`)
      ]);
      setSelected(enrichServer(profile));
      setSnapshots(history || []);
      setWipes(wipeHistory || []);
    } catch {
      setSelected(server);
      setSnapshots([]);
      setWipes([]);
    }
  };

  const copyText = async (value, message = t.copied) => {
    await navigator.clipboard?.writeText(value);
    setToast(message);
    window.setTimeout(() => setToast(''), 1600);
  };

  const toggleCompare = (server) => {
    setCompareIds((current) => {
      if (current.includes(server.id)) {
        return current.filter((id) => id !== server.id);
      }
      return [server.id, ...current].slice(0, 4);
    });
  };

  const toggleFavorite = async (server) => {
    if (currentUser.authenticated && !currentUser.admin) {
      const exists = accountFavorites.some((favorite) => favorite.id === server.id);
      try {
        if (exists) {
          await request(`/me/favorites/${server.id}`, { method: 'DELETE' });
          setAccountFavorites((current) => current.filter((favorite) => favorite.id !== server.id));
          setToast(t.favoriteRemoved);
        } else {
          const saved = await request(`/me/favorites/${server.id}`, { method: 'POST' });
          setAccountFavorites((current) => [enrichServer(saved), ...current.filter((favorite) => favorite.id !== server.id)]);
          setToast(t.favoriteSaved);
        }
        window.setTimeout(() => setToast(''), 1600);
      } catch {
        setToast(t.quietError);
        window.setTimeout(() => setToast(''), 1600);
      }
      return;
    }
    setFavoriteIds((current) => {
      if (current.includes(server.id)) {
        return current.filter((id) => id !== server.id);
      }
      return [server.id, ...current];
    });
    if (!currentUser.authenticated) {
      setToast(t.loginRequiredFavorite);
      window.setTimeout(() => setToast(''), 2200);
    }
  };

  const saveAlert = () => {
    const alerts = readJson('rustRadarAlerts', []);
    const next = [{ id: Date.now(), query: smartQuery, filters, createdAt: new Date().toISOString() }, ...alerts].slice(0, 20);
    localStorage.setItem('rustRadarAlerts', JSON.stringify(next));
    setAlertOpen(false);
    setToast(t.savedAlert);
  };

  const navigateLanding = (item) => {
    window.history.pushState({}, '', item.path);
    setRoutePath(item.path);
    setFilters((current) => ({ ...current, ...item.patch }));
    setLocalFlags(item.local || {});
    setPage(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goPath = (path) => {
    window.history.pushState({}, '', path);
    setRoutePath(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const steamLogin = () => {
    window.location.href = `${API_BASE}/auth/steam/login`;
  };

  const logout = async () => {
    await request('/auth/logout', { method: 'POST' });
    setCurrentUser({ authenticated: false, admin: false, adminVisible: false });
    setAccountFavorites([]);
    setAdminSponsors([]);
    setToast(t.logout);
    window.setTimeout(() => setToast(''), 1600);
  };

  const adminLogin = async (event) => {
    event.preventDefault();
    try {
      const me = await request('/auth/admin/login', { method: 'POST', body: JSON.stringify({ password: adminPassword }) });
      setCurrentUser(me);
      setAdminPassword('');
      setToast(t.adminLogin);
      window.setTimeout(() => setToast(''), 1600);
    } catch {
      setToast(t.quietError);
      window.setTimeout(() => setToast(''), 1800);
    }
  };

  const saveSponsor = async (event) => {
    event.preventDefault();
    const payload = sponsorPayload(sponsorDraft);
    try {
      if (sponsorDraft.id) {
        await request(`/admin/sponsors/${sponsorDraft.id}`, { method: 'PUT', body: JSON.stringify(payload) });
      } else {
        await request('/admin/sponsors', { method: 'POST', body: JSON.stringify(payload) });
      }
      setSponsorDraft(emptySponsorDraft());
      await loadAdminSponsors();
      await loadSponsors();
      setToast(t.saveSponsor);
      window.setTimeout(() => setToast(''), 1600);
    } catch {
      setToast(t.quietError);
      window.setTimeout(() => setToast(''), 1800);
    }
  };

  const deleteSponsor = async (id) => {
    try {
      await request(`/admin/sponsors/${id}`, { method: 'DELETE' });
      await loadAdminSponsors();
      await loadSponsors();
    } catch {
      setToast(t.quietError);
      window.setTimeout(() => setToast(''), 1800);
    }
  };

  const pagePath = routePath;
  const isAdminPage = pagePath === '/admin' && currentUser.adminVisible;
  const isAccountPage = pagePath === '/account';

  return (
    <div className="productShell">
      <header className="siteHeader">
        <a className="brandLockup" href="/" onClick={(event) => { event.preventDefault(); resetFilters(); goPath('/'); }}>
          <span className="brandGlyph">R</span>
          <span>
            <strong>Rust Radar</strong>
            <small>Server Intelligence</small>
          </span>
        </a>
        <nav className="topNav" aria-label="Main">
          <a href="#search">{t.navSearch}</a>
          <button type="button" onClick={() => navigateLanding(landingPages.find((item) => item.path === (lang === 'en' ? '/en/just-wiped-rust-servers' : lang === 'ru' ? '/ru/wipes' : '/de/wipes')) || landingPages[0])}>{t.navWipes}</button>
          <button type="button" onClick={() => setCompareOpen(true)}>{t.navCompare} <span>{compareIds.length}</span></button>
          <button type="button" onClick={() => goPath('/account')}>{t.account}</button>
          {currentUser.adminVisible && <button type="button" onClick={() => goPath('/admin')}>{t.admin}</button>}
        </nav>
        <div className="languageSwitch" aria-label="Language">
          {currentUser.authenticated ? (
            <button type="button" onClick={logout}>{t.logout}</button>
          ) : (
            <button type="button" onClick={steamLogin}>{t.loginSteam}</button>
          )}
          {LANGS.map((code) => (
            <button className={code === lang ? 'active' : ''} key={code} type="button" onClick={() => setLang(code)}>
              {code.toUpperCase()}
            </button>
          ))}
        </div>
      </header>

      <main>
        {isAdminPage ? (
          <AdminPage
            t={t}
            currentUser={currentUser}
            adminPassword={adminPassword}
            setAdminPassword={setAdminPassword}
            onLogin={adminLogin}
            sponsors={adminSponsors}
            draft={sponsorDraft}
            setDraft={setSponsorDraft}
            onSave={saveSponsor}
            onDelete={deleteSponsor}
          />
        ) : isAccountPage ? (
          <AccountPage
            t={t}
            currentUser={currentUser}
            favorites={accountFavorites}
            onSteamLogin={steamLogin}
            onOpen={openDetails}
            onCopy={copyText}
          />
        ) : (
          <>
        <section className="heroSection" id="search">
          <div className="heroContent">
            <p className="eyebrow">{t.heroEyebrow}</p>
            <h1>{t.heroTitle}</h1>
            <p className="heroCopy">{t.heroCopy}</p>
            <form className="smartSearch" onSubmit={submitSmartSearch}>
              <span className="searchIcon">⌕</span>
              <input value={smartQuery} onChange={(event) => setSmartQuery(event.target.value)} placeholder={t.searchPlaceholder} />
              <button type="submit">{t.searchButton}</button>
            </form>
            <div className="searchModeTabs" aria-label="Search mode">
              {[
                ['quick', ux.searchModeQuick],
                ['finder', ux.searchModeFinder],
                ['pro', ux.searchModePro]
              ].map(([mode, label]) => (
                <button
                  className={searchMode === mode ? 'active' : ''}
                  key={mode}
                  type="button"
                  onClick={() => {
                    setSearchMode(mode);
                    if (mode === 'pro') setShowFilters(true);
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
            {searchMode === 'quick' && (
              <QuickFilterChips
                chips={quickFilters}
                counts={quickFilterCounts}
                filters={filters}
                localFlags={localFlags}
                t={t}
                ux={ux}
                onApply={applyQuickFilter}
              />
            )}
            {searchMode === 'finder' && (
              <FinderPanel
                ux={ux}
                step={finderStep}
                answers={finderAnswers}
                total={enrichedServers.length}
                onBack={() => setFinderStep((current) => Math.max(0, current - 1))}
                onRestart={() => { setFinderAnswers({}); setFinderStep(0); }}
                onChoose={applyFinderChoice}
              />
            )}
          </div>
          <div className="heroStats">
            <Metric value={heroStats.totalServers} label={t.liveServers} />
            <Metric value={heroStats.onlinePlayers} label={t.playersOnline} />
            <Metric value={heroStats.justWiped} label={t.justWiped} />
            <Metric value={heroStats.verified} label={t.verifiedServers} meta={heroStats.updatedAt ? `${t.updatedAgo}: ${formatRelativePast(heroStats.updatedAt, t)}` : ''} />
          </div>
        </section>

        <ActiveSearchBar
          chips={activeChips}
          total={enrichedServers.length}
          rawTotal={total}
          ux={ux}
          t={t}
          onRemove={removeActiveChip}
          onOpenFilters={() => { setSearchMode('pro'); setShowFilters(true); }}
          onReset={resetFilters}
        />

        <PlaystylePresets ux={ux} presets={playstylePresets} onApply={applyPreset} />

        <SponsorStrip sponsors={sponsors} t={t} />

        {(showFilters || searchMode === 'pro') && <section className="filterDock">
          <div className="filterDockHeader">
            <div>
              <strong>{ux.searchModePro}</strong>
              <span>{formatNumber(enrichedServers.length)} / {formatNumber(total)} {t.servers}</span>
            </div>
            <div className="filterActions">
              <button type="button" onClick={() => setShowFilters((value) => !value)}>{showFilters ? t.hideFilters : t.allFilters}</button>
              <button type="button" onClick={resetFilters}>{t.resetFilters}</button>
            </div>
          </div>
          <div className="primaryFilterGrid">
            <Select label={t.region} value={filters.region} onChange={(value) => updateFilter('region', value)} options={['all', 'EU', 'US', 'NA', 'AU', 'SEA', 'RU']} t={t} />
            <Select label={t.type} value={filters.mode} onChange={(value) => updateFilter('mode', value)} options={['all', 'vanilla', 'modded', 'official', 'pve']} t={t} />
            <Select label={t.team} value={filters.group} onChange={(value) => updateFilter('group', value)} options={['all', 'solo', 'duo', 'trio', 'quad', '5-max', '6-max', 'no-limit']} t={t} />
            <Select label={t.gather} value={filters.gather} onChange={(value) => updateFilter('gather', value)} options={['all', '1x', '1.5x', '2x', '3x', '5x', '10x', '50x', '100x']} t={t} />
            <Select label={t.wipe} value={filters.wipe} onChange={(value) => updateFilter('wipe', value)} options={['all', 'daily', 'weekly', 'biweekly', 'monthly']} t={t} />
            <RangeFilter label={t.playersRange || t.players} min={filters.playersMin} max={filters.playersMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('playersMin', value)} onMax={(value) => updateFilter('playersMax', value)} />
          </div>
          {showFilters && (
            <div className="advancedFilterPanel">
              <div className="filterGroup">
                <strong>{t.quality}</strong>
                <div className="filterGrid">
                  <Select label={t.quality} value={filters.quality} onChange={(value) => updateFilter('quality', value)} options={['all', 'verified', 'high', 'medium']} t={t} />
                  <Select label={t.population} value={filters.population} onChange={(value) => updateFilter('population', value)} options={['all', 'high', 'medium', 'low']} t={t} />
                  <Select label={t.bpWipe} value={filters.bp} onChange={(value) => updateFilter('bp', value)} options={['all', 'no', 'yes', 'unknown']} t={t} />
                  <Select label={t.sort} value={filters.sort} onChange={(value) => updateFilter('sort', value)} options={['radar', 'players', 'wipe', 'fresh', 'confidence']} t={t} />
                </div>
              </div>
              <div className="filterGroup">
                <strong>{t.from} / {t.to}</strong>
                <div className="filterGrid">
                  <RangeFilter label={t.maxPlayersRange || 'Slots'} min={filters.maxPlayersMin} max={filters.maxPlayersMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('maxPlayersMin', value)} onMax={(value) => updateFilter('maxPlayersMax', value)} />
                  <RangeFilter label={t.pingRange || t.ping} min={filters.pingMin} max={filters.pingMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('pingMin', value)} onMax={(value) => updateFilter('pingMax', value)} />
                  <RangeFilter label={t.gatherRange || t.gather} min={filters.gatherMin} max={filters.gatherMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} step="0.5" onMin={(value) => updateFilter('gatherMin', value)} onMax={(value) => updateFilter('gatherMax', value)} />
                  <RangeFilter label={t.teamRange || t.team} min={filters.teamMin} max={filters.teamMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('teamMin', value)} onMax={(value) => updateFilter('teamMax', value)} />
                  <RangeFilter label={t.qualityRange || t.quality} min={filters.qualityMin} max={filters.qualityMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('qualityMin', value)} onMax={(value) => updateFilter('qualityMax', value)} />
                  <RangeFilter label={t.wipeAgeRange || t.lastWipe} min={filters.wipeAgeMin} max={filters.wipeAgeMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('wipeAgeMin', value)} onMax={(value) => updateFilter('wipeAgeMax', value)} />
                  <RangeFilter label={t.nextWipeRange || t.nextWipe} min={filters.nextWipeMin} max={filters.nextWipeMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('nextWipeMin', value)} onMax={(value) => updateFilter('nextWipeMax', value)} />
                  <RangeFilter label={t.mapSizeRange || t.mapSize} min={filters.mapSizeMin} max={filters.mapSizeMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} step="100" onMin={(value) => updateFilter('mapSizeMin', value)} onMax={(value) => updateFilter('mapSizeMax', value)} />
                </div>
              </div>
            </div>
          )}
        </section>}

        {toast && <div className="toast">{toast}</div>}
        {softError && <div className="softNotice">{t.quietError}</div>}

        {activeLanding && (
          <section className="landingPanel">
            <p className="eyebrow">SEO Live Page</p>
            <h2>{activeLanding.label}</h2>
            <p>{t.landingCopy}</p>
          </section>
        )}

        <RecommendationStrip
          recommendations={recommendations}
          ux={ux}
          t={t}
          onOpen={openDetails}
          onCopy={copyText}
        />

        <WipeHub buckets={wipeBuckets} t={t} onOpen={openDetails} onCopy={copyText} />

        <section className="featureGrid">
          <FeaturePanel title={t.upcomingWipes} servers={sections.upcoming} empty={t.empty} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
          <FeaturePanel title={t.justWiped} servers={sections.just} empty={t.emptyFiltered} onReset={resetFilters} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
        </section>

        <ServerSection
          title={t.topServers}
          subtitle={t.footerCopy}
          servers={enrichedServers.length ? enrichedServers : sections.top}
          t={t}
          ux={ux}
          view={resultView}
          onViewChange={setResultView}
          filters={filters}
          localFlags={localFlags}
          compareIds={compareIds}
          favoriteIds={effectiveFavoriteIds}
          onOpen={openDetails}
          onCopy={copyText}
          onCompare={toggleCompare}
          onFavorite={toggleFavorite}
          onAlert={(server) => { setSelected(server); setAlertOpen(true); }}
          onReset={resetFilters}
        />

        <section className="featureGrid">
          <FeaturePanel title={t.bestDuo} servers={sections.duo} empty={t.emptyFiltered} onReset={resetFilters} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
          <FeaturePanel title={t.bestVanilla} servers={sections.vanilla} empty={t.emptyFiltered} onReset={resetFilters} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
        </section>

        <section className="seoPanel">
          <div>
            <p className="eyebrow">{t.seoTitle}</p>
            <h2>Rust Server Finder</h2>
          </div>
          <div className="seoLinks">
            {landingPages.map((item) => (
              <button key={item.path} type="button" onClick={() => navigateLanding(item)}>{item.label}</button>
            ))}
          </div>
        </section>
          </>
        )}
      </main>

      {compareIds.length > 0 && (
        <div className="compareBar">
          <strong>{compareIds.length} {t.compareSelected}</strong>
          <div>
            <button type="button" onClick={() => setCompareOpen(true)}>{t.openCompare}</button>
            <button type="button" onClick={clearCompare}>{t.clear}</button>
          </div>
        </div>
      )}

      {selected && !alertOpen && (
        <DetailDrawer
          server={selected}
          snapshots={snapshots}
          wipes={wipes}
          t={t}
          onClose={() => setSelected(null)}
          onCopy={copyText}
          onAlert={() => setAlertOpen(true)}
        />
      )}

      {compareOpen && (
        <CompareDrawer
          servers={compareServers}
          t={t}
          onClose={() => setCompareOpen(false)}
          onRemove={(server) => toggleCompare(server)}
        />
      )}

      {alertOpen && (
        <AlertDialog
          t={t}
          server={selected}
          filters={filters}
          query={smartQuery}
          onClose={() => setAlertOpen(false)}
          onSave={saveAlert}
        />
      )}
    </div>
  );
}

function QuickFilterChips({ chips, counts, filters, localFlags, t, ux, onApply }) {
  return (
    <div className="quickChips" aria-label={t.quickFilters}>
      {chips.map((chip) => (
        <button
          className={isQuickFilterActive(chip, filters, localFlags) ? 'active' : ''}
          key={chip.id}
          type="button"
          onClick={() => onApply(chip)}
        >
          <span>{chip.labelKey ? t[chip.labelKey] : chip.label}</span>
          <small>{formatNumber(counts[chip.id] || 0)} {ux.quickFilterCountHint}</small>
        </button>
      ))}
    </div>
  );
}

function FinderPanel({ ux, step, answers, total, onBack, onRestart, onChoose }) {
  const question = finderQuestions[Math.min(step, finderQuestions.length - 1)];
  const done = Object.keys(answers).length >= finderQuestions.length;
  return (
    <div className="finderPanel">
      <div className="finderHeader">
        <div>
          <strong>{ux.finderTitle}</strong>
          <span>{ux.finderStep} {Math.min(step + 1, finderQuestions.length)} / {finderQuestions.length}</span>
        </div>
        <em>{formatNumber(total)} {ux.finderResults}</em>
      </div>
      <p>{done ? ux.finderResults : ux.finderCopy}</p>
      <div className="finderQuestion">
        <h3>{ux[question.titleKey] || question.titleKey}</h3>
        <div className="finderChoices">
          {question.choices.map((choice) => (
            <button
              className={answers[question.id] === choice.id ? 'active' : ''}
              key={choice.id}
              type="button"
              onClick={() => onChoose(question, choice)}
            >
              {choice.labelKey ? ux[choice.labelKey] : choice.label}
            </button>
          ))}
        </div>
      </div>
      <div className="finderActions">
        <button type="button" onClick={onBack} disabled={step === 0}>{ux.finderBack}</button>
        <button type="button" onClick={onRestart}>{ux.finderRestart}</button>
      </div>
    </div>
  );
}

function ActiveSearchBar({ chips, total, rawTotal, ux, t, onRemove, onOpenFilters, onReset }) {
  return (
    <section className="activeSearchBar">
      <div>
        <p className="eyebrow">{ux.activeSearch}</p>
        <strong>{formatNumber(total)} / {formatNumber(rawTotal)} {t.servers}</strong>
        <span>{chips.length ? ux.activeSearchHint : ux.noActiveFilters}</span>
      </div>
      <div className="activeChips">
        {chips.length === 0 && <span className="emptyChip">{ux.noActiveFilters}</span>}
        {chips.map((chip) => (
          <button key={chip.id} type="button" onClick={() => onRemove(chip)}>
            {chip.label}<span>×</span>
          </button>
        ))}
      </div>
      <div className="activeSearchActions">
        <button type="button" onClick={onOpenFilters}>{ux.proFilters}</button>
        <button type="button" onClick={onReset}>{t.resetFilters}</button>
      </div>
    </section>
  );
}

function PlaystylePresets({ ux, presets, onApply }) {
  return (
    <section className="playstyleSection">
      <div className="panelHeader">
        <div>
          <p className="eyebrow">{ux.searchModeFinder}</p>
          <h2>{ux.playstyleTitle}</h2>
          <span>{ux.playstyleCopy}</span>
        </div>
      </div>
      <div className="playstyleGrid">
        {presets.map((preset) => (
          <button className="playstyleCard" key={preset.id} type="button" onClick={() => onApply(preset)}>
            <strong>{ux[preset.titleKey]}</strong>
            <span>{ux[preset.copyKey]}</span>
            <em>{preset.tags.join(' · ')}</em>
          </button>
        ))}
      </div>
    </section>
  );
}

function RecommendationStrip({ recommendations, ux, t, onOpen, onCopy }) {
  const cards = [
    [ux.bestChoice, recommendations.best],
    [ux.freshestChoice, recommendations.fresh],
    [ux.strongestDataChoice, recommendations.data],
    [ux.activeChoice, recommendations.active]
  ].filter(([, server]) => server);
  if (!cards.length) return null;
  return (
    <section className="recommendationStrip">
      <div className="panelHeader">
        <div>
          <p className="eyebrow">{ux.recommendedForYou}</p>
          <h2>{ux.recommendedForYou}</h2>
        </div>
      </div>
      <div className="recommendationGrid">
        {cards.map(([label, server]) => {
          const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
          const population = displayPopulation(server);
          return (
            <article className="recommendationCard" key={`${label}-${server.id}`}>
              <span>{label}</span>
              <strong>{server.name || endpoint}</strong>
              <small>{server.matchScore}% {ux.matchForSearch} · {formatNumber(population.active)}/{formatNumber(population.max)} · {formatRelative(server.lastWipeDetected, t)}</small>
              <div>
                <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
                <button type="button" onClick={() => onOpen(server)}>{t.details}</button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

function ServerSection({ title, subtitle, servers, t, ux, view, onViewChange, filters, localFlags, compareIds, favoriteIds, onOpen, onCopy, onCompare, onFavorite, onAlert, onReset }) {
  const visible = servers.slice(0, 18);
  return (
    <section className="serverSection">
      <div className="sectionHeader">
        <div>
          <p className="eyebrow">{t.recommended}</p>
          <h2>{title}</h2>
          <span>{subtitle}</span>
        </div>
        <div className="viewSwitch" aria-label={ux.viewMode}>
          <span>{ux.viewMode}</span>
          {[
            ['recommended', ux.viewRecommended],
            ['compact', ux.viewCompact],
            ['expert', ux.viewExpert]
          ].map(([key, label]) => (
            <button className={view === key ? 'active' : ''} key={key} type="button" onClick={() => onViewChange(key)}>
              {label}
            </button>
          ))}
        </div>
      </div>
      {visible.length === 0 && <EmptyState text={t.emptyFiltered} t={t} onReset={onReset} />}
      {visible.length > 0 && view === 'expert' && (
        <ExpertServerTable
          servers={visible}
          t={t}
          ux={ux}
          onOpen={onOpen}
          onCopy={onCopy}
          onCompare={onCompare}
          compareIds={compareIds}
        />
      )}
      {visible.length > 0 && view === 'compact' && (
        <div className="compactList">
          {visible.map((server) => (
            <CompactServerRow
              key={server.id}
              server={server}
              t={t}
              ux={ux}
              isCompared={compareIds.includes(server.id)}
              onOpen={onOpen}
              onCopy={onCopy}
              onCompare={onCompare}
            />
          ))}
        </div>
      )}
      {visible.length > 0 && view === 'recommended' && (
        <div className="serverList">
          {visible.map((server) => (
            <ServerCard
              key={server.id}
              server={server}
              t={t}
              ux={ux}
              filters={filters}
              localFlags={localFlags}
              isCompared={compareIds.includes(server.id)}
              isFavorite={favoriteIds.includes(server.id)}
              onOpen={onOpen}
              onCopy={onCopy}
              onCompare={onCompare}
              onFavorite={onFavorite}
              onAlert={onAlert}
            />
          ))}
        </div>
      )}
    </section>
  );
}

function ServerCard({ server, t, ux, filters, localFlags, isCompared, isFavorite, onOpen, onCopy, onCompare, onFavorite, onAlert }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const population = displayPopulation(server);
  const bp = detectBpWipe(server);
  const matchReasons = buildMatchReasonLabels(server, filters, localFlags, ux);
  return (
    <article className="serverCard">
      <div className="serverMain">
        <div className="titleRow">
          <h3 title={server.name || endpoint}>{server.name || endpoint}</h3>
          <button className={`starButton ${isFavorite ? 'active' : ''}`} type="button" onClick={() => onFavorite(server)} aria-label={t.favorite}>★</button>
        </div>
        <div className="matchHeader">
          <strong>{server.matchScore}% {ux.matchForSearch}</strong>
          <span>{ux.whyMatches}</span>
        </div>
        <div className="matchReasons">
          {matchReasons.slice(0, 5).map((reason) => <span key={reason}>{reason}</span>)}
        </div>
        <div className="serverMeta">
          <span>{endpoint}</span>
          <span>{server.region || t.unknown}</span>
          <span>{server.mapName || t.map}</span>
        </div>
        <div className="tagRow">
          <Badge text={server.online ? t.online : t.offline} tone={server.online ? 'green' : 'red'} />
          <Badge text={server.moddedDetected ? t.modded : t.vanilla} tone={server.moddedDetected ? 'orange' : 'green'} />
          {server.official && <Badge text={t.official} tone="blue" />}
          {server.groupLimitDetected && <Badge text={server.groupLimitDetected} tone="blue" />}
          {server.gatherRateDetected && <Badge text={server.gatherRateDetected} tone="orange" />}
          {server.wipeCycleDetected && <Badge text={server.wipeCycleDetected} tone="purple" />}
          {bp.value !== 'unknown' && <Badge text={`${t.bpWipe}: ${bp.label(t)}`} tone={bp.value === 'no' ? 'green' : 'yellow'} />}
          <Badge text={`${t.dataQuality}: ${server.dataQuality}%`} tone={server.dataQuality >= 85 ? 'green' : server.dataQuality >= 65 ? 'yellow' : 'red'} />
        </div>
      </div>

      <div className="decisionGrid">
        <Info label={t.players} value={`${formatNumber(population.active)} / ${formatNumber(population.max)}`} />
        <Info label={population.queue > 0 ? t.queue : t.ping} value={population.queue > 0 ? formatNumber(population.queue) : (server.pingMs ? `${server.pingMs} ms` : t.unknown)} accent={population.queue > 0} />
        <Info label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} accent={server.isJustWiped} />
        <Info label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
        <Info label={t.team} value={server.groupLimitDetected || t.unknown} />
        <Info label={t.gather} value={server.gatherRateDetected || '1x'} />
        <Info label={t.bpWipe} value={bp.label(t)} />
        <Info label={t.mapSize} value={server.worldSize || t.unknown} />
      </div>

      <div className="scorePanel">
        <div className="scoreRing" style={{ '--score': `${server.radarScore}%` }}>
          <strong>{server.radarScore}</strong>
          <small>{t.ranking}</small>
        </div>
        <div className="popBar">
          <span style={{ width: `${population.ratio}%` }} />
        </div>
        <small>{t.source}: {sourceLabel(server, t)}</small>
        <div className="scoreReasons">
          {(server.scoreReasons || []).slice(0, 3).map((reason) => <span key={reason}>{t[reason] || reason}</span>)}
        </div>
        {server.dataWarnings?.length > 0 && (
          <div className="dataWarnings">
            {server.dataWarnings.slice(0, 2).map((warning) => <span key={warning}>{t[warning] || warning}</span>)}
          </div>
        )}
      </div>

      <div className="cardActions">
        <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
        <button type="button" onClick={() => onCopy(endpoint, t.copied)}>{t.copyIp}</button>
        <button type="button" onClick={() => onOpen(server)}>{t.details}</button>
        <button className={isCompared ? 'activeAction' : ''} type="button" onClick={() => onCompare(server)}>{t.compare}</button>
        <button type="button" onClick={() => onAlert(server)}>{t.alert}</button>
      </div>
    </article>
  );
}

function CompactServerRow({ server, t, ux, isCompared, onOpen, onCopy, onCompare }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const population = displayPopulation(server);
  return (
    <article className="compactServerRow">
      <button className="compactTitle" type="button" onClick={() => onOpen(server)}>
        <strong>{server.name || endpoint}</strong>
        <span>{server.region || t.unknown} · {server.groupLimitDetected || t.team} · {server.gatherRateDetected || '1x'} · {server.moddedDetected ? t.modded : t.vanilla}</span>
      </button>
      <span>{server.matchScore}% {ux.matchForSearch}</span>
      <span>{formatNumber(population.active)}/{formatNumber(population.max)}{population.queue > 0 ? ` +${formatNumber(population.queue)}` : ''}</span>
      <span>{formatRelative(server.lastWipeDetected, t)}</span>
      <span>{server.pingMs ? `${server.pingMs} ms` : t.unknown}</span>
      <div>
        <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
        <button className={isCompared ? 'activeAction' : ''} type="button" onClick={() => onCompare(server)}>{t.compare}</button>
      </div>
    </article>
  );
}

function ExpertServerTable({ servers, t, ux, onOpen, onCopy, onCompare, compareIds }) {
  return (
    <div className="expertTableWrap">
      <table className="expertTable">
        <thead>
          <tr>
            <th>{ux.tableServer}</th>
            <th>{ux.tableFit}</th>
            <th>{ux.tablePlayers}</th>
            <th>{ux.tableWipe}</th>
            <th>{ux.tableTeam}</th>
            <th>{ux.tableRate}</th>
            <th>{ux.tablePing}</th>
            <th>{ux.tableQuality}</th>
            <th>{ux.tableActions}</th>
          </tr>
        </thead>
        <tbody>
          {servers.map((server) => {
            const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
            const population = displayPopulation(server);
            return (
              <tr key={server.id}>
                <td>
                  <button type="button" onClick={() => onOpen(server)}>{server.name || endpoint}</button>
                  <span>{endpoint}</span>
                </td>
                <td>{server.matchScore}%</td>
                <td>{formatNumber(population.active)}/{formatNumber(population.max)}{population.queue > 0 ? ` +${formatNumber(population.queue)}` : ''}</td>
                <td>{formatRelative(server.lastWipeDetected, t)}</td>
                <td>{server.groupLimitDetected || t.unknown}</td>
                <td>{server.gatherRateDetected || '1x'}</td>
                <td>{server.pingMs ? `${server.pingMs} ms` : t.unknown}</td>
                <td>{server.dataQuality}%</td>
                <td>
                  <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
                  <button className={compareIds.includes(server.id) ? 'activeAction' : ''} type="button" onClick={() => onCompare(server)}>{t.compare}</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function DetailDrawer({ server, snapshots, wipes, t, onClose, onCopy, onAlert }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const rules = Object.entries(server.rules || {}).slice(0, 80);
  const bp = detectBpWipe(server);
  const population = displayPopulation(server);
  return (
    <aside className="drawerOverlay">
      <div className="detailDrawer">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.profile}</p>
            <h2>{server.name || endpoint}</h2>
            <span>{endpoint}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>

        <div className="drawerActions">
          <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
          <button type="button" onClick={() => onCopy(endpoint, t.copied)}>{t.copyIp}</button>
          <button type="button" onClick={onAlert}>{t.alert}</button>
        </div>

        <div className="drawerBody">
          <section>
            <h3>{t.overview}</h3>
            <div className="kvGrid">
              <Kv label={t.fullName} value={server.name || '-'} />
              <Kv label={t.endpoint} value={endpoint} />
              <Kv label={t.status} value={server.online ? t.online : t.offline} />
              <Kv label={t.mode} value={server.official ? t.official : server.moddedDetected ? t.modded : t.vanilla} />
              <Kv label={t.players} value={`${formatNumber(population.active)} / ${formatNumber(population.max)}`} />
              {population.queue > 0 && <Kv label={t.queue} value={formatNumber(population.queue)} />}
              <Kv label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
              <Kv label={t.region} value={server.region || t.unknown} />
              <Kv label={t.team} value={server.groupLimitDetected || t.unknown} />
              <Kv label={t.gather} value={server.gatherRateDetected || '1x'} />
              <Kv label={t.bpWipe} value={bp.label(t)} />
              <Kv label={`${t.bpWipe} ${t.source}`} value={bp.source || t.unknown} />
              <Kv label={`${t.bpWipe} ${t.confidence}`} value={bp.confidence || t.uncertain} />
              <Kv label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} />
              <Kv label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
              <Kv label={t.map} value={server.mapName || t.unknown} />
              <Kv label={t.mapSize} value={server.worldSize || t.unknown} />
              <Kv label={`${t.mapSize} ${t.source}`} value={server.mapSizeSource || t.unknown} />
              <Kv label={t.dataQuality} value={`${server.dataQuality}%`} />
              <Kv label={t.source} value={sourceLabel(server, t)} />
              <Kv label={t.ownerStatus} value={t.notClaimed} />
            </div>
          </section>

          <section>
            <h3>{t.scoreBreakdown}</h3>
            <ScoreBreakdown server={server} t={t} />
          </section>

          <section>
            <h3>{t.history}</h3>
            <HistoryBars snapshots={snapshots} t={t} />
          </section>

          <section>
            <h3>{t.wipeHistory}</h3>
            {wipes.length === 0 && <div className="emptyState compact">{t.noHistory}</div>}
            <div className="wipeList">
              {wipes.map((wipe) => (
                <Kv key={`${wipe.detectedAt}-${wipe.detectedBy}`} label={wipe.detectedBy || t.historyEstimated} value={`${wipe.type || t.unknown} · ${Math.round((wipe.confidence || 0) * 100)}% · ${formatDate(wipe.detectedAt, true) || '-'}`} />
              ))}
            </div>
          </section>

          <section>
            <h3>{t.rules}</h3>
            {rules.length === 0 && <div className="emptyState compact">{t.noHistory}</div>}
            {rules.length > 0 && (
              <table className="rulesTable">
                <tbody>
                  {rules.map(([key, value]) => <tr key={key}><td>{key}</td><td>{value}</td></tr>)}
                </tbody>
              </table>
            )}
          </section>
        </div>
      </div>
    </aside>
  );
}

function CompareDrawer({ servers, t, onClose, onRemove }) {
  return (
    <aside className="drawerOverlay">
      <div className="compareDrawer">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.navCompare}</p>
            <h2>{t.compareServers}</h2>
            <span>{t.compareHint}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>
        {servers.length === 0 && <div className="emptyState">{t.compareHint}</div>}
        {servers.length > 0 && (
          <div className="compareGrid">
            {servers.map((server) => (
              <CompareCard key={server.id} server={server} t={t} onRemove={onRemove} />
            ))}
          </div>
        )}
      </div>
    </aside>
  );
}

function AlertDialog({ t, server, filters, query, onClose, onSave }) {
  return (
    <aside className="drawerOverlay">
      <div className="alertDialog">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.alert}</p>
            <h2>{t.createAlert}</h2>
            <span>{server?.name || query || t.heroTitle}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>
        <p>{t.alertCopy}</p>
        <div className="kvGrid">
          <Kv label={t.region} value={filters.region} />
          <Kv label={t.team} value={filters.group} />
          <Kv label={t.gather} value={filters.gather} />
          <Kv label={t.wipe} value={filters.wipe} />
        </div>
        <button className="connectButton wide" type="button" onClick={onSave}>{t.saveAlert}</button>
      </div>
    </aside>
  );
}

function SponsorStrip({ sponsors, t }) {
  if (!sponsors.length) {
    return null;
  }
  return (
    <section className="sponsorStrip">
      <div className="panelHeader">
        <div>
          <p className="eyebrow">{t.sponsored}</p>
          <h2>{t.sponsorLive}</h2>
          <span>{t.sponsorCopy}</span>
        </div>
      </div>
      <div className="sponsorGrid">
        {sponsors.slice(0, 3).map((sponsor) => (
          <a className="sponsorCard" href={sponsor.targetUrl || '#'} target={sponsor.targetUrl ? '_blank' : undefined} rel="noreferrer" key={sponsor.id}>
            {sponsor.imageUrl && <img src={sponsor.imageUrl} alt="" />}
            <span className="badge orange">{t.sponsored}</span>
            <strong>{sponsor.title || t.sponsored}</strong>
            <small>{sponsor.description || sponsor.targetUrl}</small>
          </a>
        ))}
      </div>
    </section>
  );
}

function AccountPage({ t, currentUser, favorites, onSteamLogin, onOpen, onCopy }) {
  if (!currentUser.authenticated || currentUser.admin) {
    return (
      <section className="accountPage">
        <p className="eyebrow">{t.account}</p>
        <h1>{t.loginSteam}</h1>
        <p>{t.steamLoginCopy}</p>
        <button className="connectButton" type="button" onClick={onSteamLogin}>{t.loginSteam}</button>
      </section>
    );
  }
  return (
    <section className="accountPage">
      <p className="eyebrow">{t.account}</p>
      <div className="accountHeader">
        {currentUser.avatarUrl && <img src={currentUser.avatarUrl} alt="" />}
        <div>
          <h1>{t.signedInAs} {currentUser.displayName || currentUser.steamId}</h1>
          <span>{currentUser.steamId}</span>
        </div>
      </div>
      <h2>{t.favorites}</h2>
      {favorites.length === 0 && <div className="emptyState">{t.noFavorites}</div>}
      <div className="accountFavorites">
        {favorites.map((server) => {
          const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
          return (
            <div className="favoriteAccountCard" key={server.id}>
              <MiniServer server={server} t={t} onOpen={onOpen} />
              <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
            </div>
          );
        })}
      </div>
    </section>
  );
}

function AdminPage({ t, currentUser, adminPassword, setAdminPassword, onLogin, sponsors, draft, setDraft, onSave, onDelete }) {
  if (!currentUser.admin) {
    return (
      <section className="adminPage">
        <p className="eyebrow">{t.admin}</p>
        <h1>{t.adminLogin}</h1>
        <p>{t.adminHint}</p>
        <form className="adminLoginForm" onSubmit={onLogin}>
          <label>
            <span>{t.adminPassword}</span>
            <input type="password" value={adminPassword} onChange={(event) => setAdminPassword(event.target.value)} />
          </label>
          <button className="connectButton" type="submit">{t.login}</button>
        </form>
      </section>
    );
  }

  return (
    <section className="adminPage">
      <p className="eyebrow">{t.adminPanel}</p>
      <h1>{t.sponsorAdmin}</h1>
      <p>{t.adminHint}</p>
      <form className="sponsorForm" onSubmit={onSave}>
        <div className="formHeader">
          <h2>{draft.id ? draft.title || t.sponsorAdmin : t.newSponsor}</h2>
          <button type="button" onClick={() => setDraft(emptySponsorDraft())}>{t.newSponsor}</button>
        </div>
        <label><span>{t.sponsorTitle}</span><input value={draft.title} onChange={(event) => setDraft({ ...draft, title: event.target.value })} /></label>
        <label><span>{t.sponsorDescription}</span><textarea value={draft.description} onChange={(event) => setDraft({ ...draft, description: event.target.value })} /></label>
        <div className="formGrid">
          <label><span>{t.sponsorImage}</span><input value={draft.imageUrl} onChange={(event) => setDraft({ ...draft, imageUrl: event.target.value })} /></label>
          <label><span>{t.sponsorTarget}</span><input value={draft.targetUrl} onChange={(event) => setDraft({ ...draft, targetUrl: event.target.value })} /></label>
          <label><span>{t.sponsorPlacement}</span><input value={draft.placement} onChange={(event) => setDraft({ ...draft, placement: event.target.value })} /></label>
          <label><span>{t.sponsorServerId}</span><input type="number" min="0" value={draft.serverId} onChange={(event) => setDraft({ ...draft, serverId: event.target.value })} /></label>
          <label><span>{t.sponsorPriority}</span><input type="number" value={draft.priority} onChange={(event) => setDraft({ ...draft, priority: event.target.value })} /></label>
          <label><span>{t.sponsorStarts}</span><input type="datetime-local" value={draft.startsAt} onChange={(event) => setDraft({ ...draft, startsAt: event.target.value })} /></label>
          <label><span>{t.sponsorEnds}</span><input type="datetime-local" value={draft.endsAt} onChange={(event) => setDraft({ ...draft, endsAt: event.target.value })} /></label>
          <label className="checkLabel"><input type="checkbox" checked={draft.active} onChange={(event) => setDraft({ ...draft, active: event.target.checked })} /><span>{t.sponsorActive}</span></label>
        </div>
        <button className="connectButton wide" type="submit">{t.saveSponsor}</button>
      </form>

      <section className="sponsorListAdmin">
        <h2>{t.currentSponsors}</h2>
        {sponsors.length === 0 && <div className="emptyState compact">{t.empty}</div>}
        {sponsors.map((sponsor) => (
          <div className="adminSponsorRow" key={sponsor.id}>
            <div>
              <strong>{sponsor.title}</strong>
              <span>{sponsor.placement} · {sponsor.active ? t.online : t.offline} · #{sponsor.priority}</span>
            </div>
            <div>
              <button type="button" onClick={() => setDraft(draftFromSponsor(sponsor))}>{t.details}</button>
              <button type="button" onClick={() => window.confirm(`${t.deleteSponsor}?`) && onDelete(sponsor.id)}>{t.deleteSponsor}</button>
            </div>
          </div>
        ))}
      </section>
    </section>
  );
}

function WipeHub({ buckets, t, onOpen, onCopy }) {
  return (
    <section className="wipeHub" id="wipes">
      <div className="panelHeader">
        <div>
          <p className="eyebrow">Wipe Intelligence</p>
          <h2>{t.justWiped}</h2>
          <span>{t.wipeHubCopy}</span>
        </div>
      </div>
      <div className="wipeBuckets">
        {buckets.map((bucket) => (
          <div className="wipeBucket" key={bucket.key}>
            <div className="wipeBucketHeader">
              <strong>{t[bucket.label] || bucket.label}</strong>
              <span>{bucket.servers.length}</span>
            </div>
            {bucket.servers.length === 0 && <div className="emptyState compact">{t.empty}</div>}
            {bucket.servers.map((server) => {
              const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
              const population = displayPopulation(server);
              return (
                <div className="wipeItem" key={`${bucket.key}-${server.id}`}>
                  <button type="button" onClick={() => onOpen(server)}>
                    <strong>{server.name || endpoint}</strong>
                    <small>{formatRelative(server.lastWipeDetected, t)} · {server.groupLimitDetected || t.team} · {server.gatherRateDetected || '1x'} · {formatNumber(population.active)}/{formatNumber(population.max)}</small>
                  </button>
                  <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </section>
  );
}

function ScoreBreakdown({ server, t }) {
  const parts = server.scoreParts || {};
  const rows = [
    [t.scoreWipe, parts.wipe],
    [t.scorePopulation, parts.population],
    [t.scoreQuality, parts.quality],
    [t.scorePing, parts.ping],
    [t.scoreStatus, parts.status]
  ];
  return (
    <div className="scoreBreakdown">
      <div className="scoreTotal">
        <strong>{server.radarScore}</strong>
        <span>{t.ranking}</span>
      </div>
      <div className="scoreRows">
        {rows.map(([label, value]) => (
          <div className="scoreRow" key={label}>
            <span>{label}</span>
            <div><i style={{ width: `${Math.max(0, Math.min(100, value || 0))}%` }} /></div>
            <strong>{Math.round(value || 0)}</strong>
          </div>
        ))}
      </div>
      <div className="scoreReasons wide">
        {(server.scoreReasons || []).map((reason) => <span key={reason}>{t[reason] || reason}</span>)}
      </div>
      {server.dataWarnings?.length > 0 && (
        <div className="dataWarnings wide">
          {server.dataWarnings.map((warning) => <span key={warning}>{t[warning] || warning}</span>)}
        </div>
      )}
      <p className="sourceNote">{t.ownerVerifiedOnly}</p>
    </div>
  );
}

function CompareCard({ server, t, onRemove }) {
  const population = displayPopulation(server);
  return (
    <div className="compareCard">
      <button type="button" onClick={() => onRemove(server)}>{t.remove}</button>
      <h3>{server.name}</h3>
      <Kv label={t.players} value={`${formatNumber(population.active)} / ${formatNumber(population.max)}`} />
      {population.queue > 0 && <Kv label={t.queue} value={formatNumber(population.queue)} />}
      <Kv label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
      <Kv label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} />
      <Kv label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
      <Kv label={t.team} value={server.groupLimitDetected || t.unknown} />
      <Kv label={t.gather} value={server.gatherRateDetected || '1x'} />
      <Kv label={t.dataQuality} value={`${server.dataQuality}%`} />
      <Kv label={t.ranking} value={server.radarScore} />
      <Kv label={t.source} value={sourceLabel(server, t)} />
    </div>
  );
}

function EmptyState({ text, t, onReset, compact }) {
  return (
    <div className={`emptyState ${compact ? 'compact' : ''}`}>
      <span>{text}</span>
      {onReset && (
        <div className="emptyActions">
          <button type="button" onClick={onReset}>{t.resetFilters}</button>
        </div>
      )}
    </div>
  );
}

function FeaturePanel({ title, servers, empty, render, t, onReset }) {
  return (
    <section className="featurePanel">
      <div className="panelHeader">
        <h2>{title}</h2>
      </div>
      {servers.length === 0 ? <EmptyState compact text={empty} t={t} onReset={onReset} /> : <div className="miniList">{servers.map(render)}</div>}
    </section>
  );
}

function MiniServer({ server, t, onOpen }) {
  const population = displayPopulation(server);
  return (
    <button className="miniServer" type="button" onClick={() => onOpen(server)}>
      <span>
        <strong>{server.name}</strong>
        <small>{server.region || t.unknown} · {server.groupLimitDetected || t.team} · {server.gatherRateDetected || '1x'}</small>
      </span>
      <em>{formatNumber(population.active)}/{formatNumber(population.max)}{population.queue > 0 ? ` +${formatNumber(population.queue)}` : ''}</em>
    </button>
  );
}

function HistoryBars({ snapshots, t }) {
  if (!snapshots.length) {
    return <div className="emptyState compact">{t.noHistory}</div>;
  }
  return (
    <div className="historyBars">
      {snapshots.slice(0, 24).map((snapshot) => (
        <div className="historyRow" key={snapshot.capturedAt}>
          <span>{formatDate(snapshot.capturedAt, true) || '-'}</span>
          <div className="bar"><i style={{ width: `${displayPopulation(snapshot).ratio}%` }} /></div>
          <strong>{displayPopulation(snapshot).active || 0}/{displayPopulation(snapshot).max || 0}</strong>
        </div>
      ))}
    </div>
  );
}

function Select({ label, value, options, onChange, t }) {
  return (
    <label>
      <span>{label}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {options.map((option) => <option key={option} value={option}>{optionLabel(option, t)}</option>)}
      </select>
    </label>
  );
}

function RangeFilter({ label, min, max, minLabel, maxLabel, onMin, onMax, step = '1' }) {
  return (
    <label className="rangeFilter">
      <span>{label}</span>
      <div className="rangeInputs">
        <input type="number" inputMode="decimal" min="0" step={step} value={min} onChange={(event) => onMin(event.target.value)} placeholder={minLabel} />
        <input type="number" inputMode="decimal" min="0" step={step} value={max} onChange={(event) => onMax(event.target.value)} placeholder={maxLabel} />
      </div>
    </label>
  );
}

function Metric({ value, label, meta }) {
  return (
    <div className="metricCard">
      <strong>{formatNumber(value)}</strong>
      <span>{label}</span>
      {meta && <small>{meta}</small>}
    </div>
  );
}

function Info({ label, value, accent }) {
  return (
    <div className={`infoCell ${accent ? 'accent' : ''}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function Kv({ label, value }) {
  return <div className="kv"><span>{label}</span><strong>{String(value ?? '-')}</strong></div>;
}

function Badge({ text, tone }) {
  return <span className={`badge ${tone || ''}`}>{text}</span>;
}

function enrichServer(server) {
  const dataQuality = Math.round((server.confidenceScore || 0.45) * 100);
  const radar = calculateRadarScore(server, dataQuality);
  const wipeAge = ageMinutes(server.lastWipeDetected);
  const isJustWiped = wipeAge !== null && wipeAge < 1440;
  return {
    ...server,
    dataQuality,
    radarScore: radar.total,
    scoreParts: radar.parts,
    scoreReasons: radar.reasons,
    dataWarnings: radar.warnings,
    isJustWiped
  };
}

function calculateRadarScore(server, dataQuality) {
  const population = displayPopulation(server);
  const wipeAge = ageMinutes(server.lastWipeDetected);
  const wipe = wipeAge === null ? 20 : Math.max(25, 100 - Math.floor(wipeAge / 18));
  const ping = server.pingMs ? Math.max(10, 100 - Math.floor(server.pingMs * 0.9)) : 45;
  const status = server.online ? 100 : 10;
  const parts = {
    wipe,
    population: population.ratio,
    quality: dataQuality,
    ping,
    status
  };
  const warnings = [];
  const reasons = [];

  if (wipeAge !== null && wipeAge <= 180) reasons.push('freshWipe');
  if (population.active >= 30 && population.ratio <= 98) reasons.push('stablePop');
  if (hasStrongSource({ ...server, dataQuality })) reasons.push('strongData');
  if (detectBpWipe(server).value === 'unknown') reasons.push('bpUnclear');
  if (population.queue > 0) warnings.push('queueDetected');
  if (population.raw > 0 && population.max > 0 && population.raw > population.max * 1.25) warnings.push('fakeRiskHigh');
  else if (population.queue > 0 || dataQuality < 55) warnings.push('fakeRiskMedium');
  else warnings.push('fakeRiskLow');

  const score = Math.round((parts.wipe * 0.22) + (parts.population * 0.22) + (parts.quality * 0.28) + (parts.ping * 0.14) + (parts.status * 0.14));
  return {
    total: Math.max(1, Math.min(99, score)),
    parts,
    reasons,
    warnings
  };
}

function applyMatchContext(server, filters, localFlags) {
  const checks = [];
  const population = displayPopulation(server);
  const bp = detectBpWipe(server);
  const add = (active, matches) => {
    if (active) checks.push(Boolean(matches));
  };

  add(filters.region !== 'all', server.region === filters.region || (filters.region === 'EU' && /eu|de|fr|nl|uk|ger/i.test(`${server.region || ''} ${server.name || ''}`)));
  add(filters.group !== 'all', String(server.groupLimitDetected || '').toLowerCase().includes(filters.group.replace('-max', '')));
  add(filters.gather !== 'all', server.gatherRateDetected === filters.gather);
  add(filters.mode !== 'all', modeMatches(server, filters.mode));
  add(filters.wipe !== 'all', String(server.wipeCycleDetected || '').toLowerCase() === filters.wipe);
  add(filters.bp !== 'all', bp.value === filters.bp);
  add(Boolean(localFlags.justWiped), server.isJustWiped);
  add(Boolean(filters.lowPing), server.pingMs && server.pingMs <= 80);
  add(filters.population !== 'all', populationMatches(population.active, filters.population));
  add(filters.quality !== 'all', qualityMatches(server.dataQuality, filters.quality));
  add(hasValue(filters.playersMin) || hasValue(filters.playersMax) || Number(filters.minPlayers) > 0, inRange(population.active, filters.playersMin || filters.minPlayers, filters.playersMax));
  add(hasValue(filters.pingMin) || hasValue(filters.pingMax), inRange(server.pingMs, filters.pingMin, filters.pingMax));
  add(hasValue(filters.gatherMin) || hasValue(filters.gatherMax), inRange(parseRateValue(server.gatherRateDetected), filters.gatherMin, filters.gatherMax));
  add(hasValue(filters.teamMin) || hasValue(filters.teamMax), inRange(parseTeamValue(server.groupLimitDetected), filters.teamMin, filters.teamMax));
  add(hasValue(filters.qualityMin) || hasValue(filters.qualityMax), inRange(server.dataQuality, filters.qualityMin, filters.qualityMax));
  add(hasValue(filters.wipeAgeMin) || hasValue(filters.wipeAgeMax), inRange(ageMinutes(server.lastWipeDetected), filters.wipeAgeMin, filters.wipeAgeMax));
  add(hasValue(filters.nextWipeMin) || hasValue(filters.nextWipeMax), inRange(hoursUntil(server.nextWipeEstimated), filters.nextWipeMin, filters.nextWipeMax));
  add(hasValue(filters.mapSizeMin) || hasValue(filters.mapSizeMax), inRange(server.worldSize, filters.mapSizeMin, filters.mapSizeMax));

  const matchScore = checks.length
    ? Math.round((checks.filter(Boolean).length / checks.length) * 100)
    : Math.max(58, Math.min(99, server.radarScore || 70));

  return { ...server, matchScore };
}

function buildMatchReasonLabels(server, filters, localFlags, ux) {
  const labels = [];
  const add = (active, matches, label) => {
    if (active && matches) labels.push(label);
  };
  const population = displayPopulation(server);
  const bp = detectBpWipe(server);
  add(filters.region !== 'all', server.region === filters.region || (filters.region === 'EU' && /eu|de|fr|nl|uk|ger/i.test(`${server.region || ''} ${server.name || ''}`)), ux.matchRegion);
  add(filters.group !== 'all' || hasValue(filters.teamMax), Boolean(server.groupLimitDetected), ux.matchTeam);
  add(filters.gather !== 'all' || hasValue(filters.gatherMin) || hasValue(filters.gatherMax), Boolean(server.gatherRateDetected), ux.matchGather);
  add(filters.mode !== 'all', modeMatches(server, filters.mode), ux.matchMode);
  add(Boolean(localFlags.justWiped) || hasValue(filters.wipeAgeMax), server.isJustWiped || ageMinutes(server.lastWipeDetected) !== null, ux.matchFresh);
  add(filters.bp !== 'all', bp.value === filters.bp, ux.matchBp);
  add(Boolean(filters.lowPing) || hasValue(filters.pingMax), server.pingMs && server.pingMs <= Number(filters.pingMax || 80), ux.matchPing);
  add(filters.quality !== 'all' || hasValue(filters.qualityMin), server.dataQuality >= Number(filters.qualityMin || 55), ux.matchQuality);
  add(filters.population !== 'all' || hasValue(filters.playersMin), population.active > 0, ux.matchPopulation);
  if (!labels.length) {
    labels.push(ux.matchPopulation, ux.matchQuality, server.isJustWiped ? ux.matchFresh : ux.mismatchUnverified);
  }
  return [...new Set(labels)].slice(0, 6);
}

function buildActiveChips(filters, localFlags, smartQuery, t, ux) {
  const chips = [];
  const addFilter = (key, label) => {
    if (filters[key] !== defaultFilters[key]) chips.push({ id: `filter-${key}`, kind: 'filter', key, label });
  };
  if (filters.query) chips.push({ id: 'query', kind: 'query', label: filters.query });
  if (localFlags.justWiped) chips.push({ id: 'local-justWiped', kind: 'local', key: 'justWiped', label: t.justWiped });
  addFilter('region', filters.region);
  addFilter('mode', optionLabel(filters.mode, t));
  addFilter('group', optionLabel(filters.group, t));
  addFilter('gather', filters.gather);
  addFilter('wipe', optionLabel(filters.wipe, t));
  addFilter('bp', `${t.bpWipe}: ${optionLabel(filters.bp, t)}`);
  addFilter('population', `${t.population}: ${optionLabel(filters.population, t)}`);
  addFilter('quality', `${t.quality}: ${optionLabel(filters.quality, t)}`);
  if (filters.lowPing) chips.push({ id: 'filter-lowPing', kind: 'filter', key: 'lowPing', label: t.lowPing });
  [
    [['playersMin', 'playersMax'], t.playersRange],
    [['maxPlayersMin', 'maxPlayersMax'], t.maxPlayersRange],
    [['pingMin', 'pingMax'], t.pingRange],
    [['gatherMin', 'gatherMax'], t.gatherRange],
    [['teamMin', 'teamMax'], t.teamRange],
    [['qualityMin', 'qualityMax'], t.qualityRange],
    [['wipeAgeMin', 'wipeAgeMax'], t.wipeAgeRange],
    [['nextWipeMin', 'nextWipeMax'], t.nextWipeRange],
    [['mapSizeMin', 'mapSizeMax'], t.mapSizeRange]
  ].forEach(([keys, label]) => {
    const [minKey, maxKey] = keys;
    if (hasValue(filters[minKey]) || hasValue(filters[maxKey])) {
      chips.push({
        id: `range-${minKey}`,
        kind: 'range',
        keys,
        label: `${label}: ${filters[minKey] || ux.any} - ${filters[maxKey] || ux.any}`
      });
    }
  });
  return chips;
}

function buildQuickFilterCounts(servers) {
  return quickFilters.reduce((counts, chip) => {
    counts[chip.id] = servers.filter((server) => matchesQuickFilter(server, chip)).length;
    return counts;
  }, {});
}

function matchesQuickFilter(server, chip) {
  const population = displayPopulation(server);
  if (chip.id === 'just-wiped') return server.isJustWiped;
  if (chip.id === 'eu') return server.region === 'EU' || /eu|de|ger|germany/i.test(`${server.region || ''} ${server.name || ''}`);
  if (chip.id === 'solo' || chip.id === 'duo' || chip.id === 'trio') return String(server.groupLimitDetected || '').toLowerCase().includes(chip.id);
  if (chip.id === '2x') return server.gatherRateDetected === '2x' || parseRateValue(server.gatherRateDetected) === 2;
  if (chip.id === 'vanilla') return !server.moddedDetected;
  if (chip.id === 'monthly') return String(server.wipeCycleDetected || '').toLowerCase() === 'monthly';
  if (chip.id === 'no-bp') return detectBpWipe(server).value === 'no';
  if (chip.id === 'pve') return /pve/i.test(`${server.name || ''} ${(server.tags || []).join(' ')}`);
  if (chip.id === 'low-ping') return server.pingMs && server.pingMs <= 80;
  return population.active > 0;
}

function buildRecommendations(servers) {
  const byMatch = [...servers].sort((a, b) => (b.matchScore - a.matchScore) || (b.radarScore - a.radarScore));
  const byFresh = [...servers].filter((server) => server.lastWipeDetected).sort((a, b) => dateValue(b.lastWipeDetected) - dateValue(a.lastWipeDetected));
  const byData = [...servers].sort((a, b) => b.dataQuality - a.dataQuality);
  const byActive = [...servers].sort((a, b) => displayPopulation(b).active - displayPopulation(a).active);
  return { best: byMatch[0], fresh: byFresh[0], data: byData[0], active: byActive[0] };
}

function modeMatches(server, mode) {
  if (mode === 'all') return true;
  if (mode === 'vanilla') return !server.moddedDetected && !server.official;
  if (mode === 'modded') return Boolean(server.moddedDetected);
  if (mode === 'official') return Boolean(server.official);
  if (mode === 'pve') return /pve/i.test(`${server.name || ''} ${(server.tags || []).join(' ')}`);
  return true;
}

function populationMatches(activePlayers, value) {
  if (value === 'high') return activePlayers >= 100;
  if (value === 'medium') return activePlayers >= 30 && activePlayers < 100;
  if (value === 'low') return activePlayers < 30;
  return true;
}

function qualityMatches(quality, value) {
  if (value === 'verified') return quality >= 90;
  if (value === 'high') return quality >= 75;
  if (value === 'medium') return quality >= 55;
  return true;
}

function applyLocalFilters(server, filters, localFlags) {
  if (localFlags.justWiped && !server.isJustWiped) return false;
  const population = displayPopulation(server);
  if (!inRange(population.active, filters.playersMin || filters.minPlayers, filters.playersMax)) return false;
  if (!inRange(server.maxPlayers, filters.maxPlayersMin, filters.maxPlayersMax)) return false;
  if (!inRange(server.pingMs, filters.pingMin, filters.pingMax)) return false;
  if (!inRange(parseRateValue(server.gatherRateDetected), filters.gatherMin, filters.gatherMax)) return false;
  if (!inRange(parseTeamValue(server.groupLimitDetected), filters.teamMin, filters.teamMax)) return false;
  if (!inRange(server.dataQuality, filters.qualityMin, filters.qualityMax)) return false;
  if (!inRange(server.worldSize, filters.mapSizeMin, filters.mapSizeMax)) return false;
  if (!inRange(ageMinutes(server.lastWipeDetected), filters.wipeAgeMin, filters.wipeAgeMax)) return false;
  if (!inRange(hoursUntil(server.nextWipeEstimated), filters.nextWipeMin, filters.nextWipeMax)) return false;
  if (filters.quality === 'verified' && server.dataQuality < 90) return false;
  if (filters.quality === 'high' && server.dataQuality < 75) return false;
  if (filters.quality === 'medium' && server.dataQuality < 55) return false;
  if (filters.population === 'high' && population.active < 100) return false;
  if (filters.population === 'medium' && (population.active < 30 || population.active >= 100)) return false;
  if (filters.population === 'low' && population.active >= 30) return false;
  if (filters.lowPing && (!server.pingMs || server.pingMs > 80)) return false;
  if (filters.bp !== 'all' && detectBpWipe(server).value !== filters.bp) return false;
  return true;
}

function inRange(value, min, max) {
  const hasMin = hasValue(min) && Number(min) > 0;
  const hasMax = hasValue(max) && Number(max) > 0;
  if (!hasMin && !hasMax) return true;
  if (value === undefined || value === null || Number.isNaN(Number(value))) return false;
  const numeric = Number(value);
  if (hasMin && numeric < Number(min)) return false;
  if (hasMax && numeric > Number(max)) return false;
  return true;
}

function parseRateValue(value) {
  if (!value) return null;
  const match = String(value).replace(',', '.').match(/(\d+(?:\.\d+)?)/);
  return match ? Number(match[1]) : null;
}

function parseTeamValue(value) {
  if (!value) return null;
  const text = String(value).toLowerCase();
  if (text.includes('solo')) return 1;
  if (text.includes('duo')) return 2;
  if (text.includes('trio')) return 3;
  if (text.includes('quad')) return 4;
  if (text.includes('no-limit') || text.includes('nolimit') || text.includes('unlimited') || text.includes('clan')) return 999;
  const match = text.match(/\d+/);
  return match ? Number(match[0]) : null;
}

function ageMinutes(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const diff = Date.now() - date.getTime();
  if (diff < -5 * 60000) return null;
  return Math.max(0, Math.floor(diff / 60000));
}

function hoursUntil(value) {
  if (!value) return null;
  return Math.max(0, Math.ceil((new Date(value).getTime() - Date.now()) / 3600000));
}

function sortLocal(a, b, sort) {
  if (sort === 'radar') return (b.matchScore - a.matchScore) || (b.radarScore - a.radarScore);
  if (sort === 'players') return displayPopulation(b).active - displayPopulation(a).active;
  if (sort === 'wipe') return dateValue(b.lastWipeDetected) - dateValue(a.lastWipeDetected);
  if (sort === 'fresh') return dateValue(b.lastSuccessfulQuery) - dateValue(a.lastSuccessfulQuery);
  if (sort === 'confidence') return b.dataQuality - a.dataQuality;
  return b.radarScore - a.radarScore;
}

function parseSmartSearch(query) {
  if (query !== undefined) {
    return parseSmartSearchInput(query);
  }
  const value = query.toLowerCase();
  const filters = {};
  const local = {};

  if (/\beu\b/.test(value)) filters.region = 'EU';
  if (/\b(us|usa)\b/.test(value)) filters.region = 'US';
  if (/\b(na)\b/.test(value)) filters.region = 'NA';
  if (/\b(au)\b/.test(value)) filters.region = 'AU';
  if (/\b(ru|russian|рус|русский)\b/.test(value)) filters.region = 'RU';

  if (/\bsolo\b|соло/.test(value)) filters.group = 'solo';
  if (/\bduo\b|дуо/.test(value)) filters.group = 'duo';
  if (/\btrio\b|трио/.test(value)) filters.group = 'trio';
  if (/\bquad\b/.test(value)) filters.group = 'quad';

  const rate = value.match(/\b(1\.5|1,5|2|3|5|10|50|100)\s*x\b/);
  if (rate) filters.gather = `${rate[1].replace(',', '.')}x`;

  if (/vanilla/.test(value)) filters.mode = 'vanilla';
  if (/modded|oxide|carbon|kits|tp|teleport|shop|мод/.test(value)) filters.mode = 'modded';
  if (/\bpve\b|зомби|zombies/.test(value)) filters.mode = 'pve';
  if (/official|facepunch/.test(value)) filters.mode = 'official';

  if (/weekly/.test(value)) filters.wipe = 'weekly';
  if (/biweekly|bi-weekly/.test(value)) filters.wipe = 'biweekly';
  if (/monthly/.test(value)) filters.wipe = 'monthly';
  if (/daily/.test(value)) filters.wipe = 'daily';
  if (/wiped today|just wiped|fresh wipe|gerade gewiped|недавний вайп|вайп/.test(value)) {
    filters.sort = 'wipe';
    local.justWiped = true;
  }
  if (/no bp|no blueprint|kein bp|без вайпа чертежей|без bp/.test(value)) {
    filters.bp = 'no';
  }
  if (/high pop|full|voll/.test(value)) filters.population = 'high';
  if (/low pop|empty|leer/.test(value)) filters.population = 'low';
  if (/low ping|ping/.test(value)) filters.lowPing = true;

  return { filters, local };
}

function detectBpWipe(server) {
  if (server.bpWipeDetected && server.bpWipeDetected !== 'unknown') {
    const value = server.bpWipeDetected;
    return {
      value,
      confidence: server.bpWipeConfidence,
      source: server.bpWipeSource,
      label: (t) => value === 'no' ? t.no : t.yes
    };
  }
  const text = `${server.name || ''} ${server.description || ''} ${(server.tags || []).join(' ')}`.toLowerCase();
  if (/no bp|no blueprint|kein bp|без вайпа чертежей|без bp/.test(text)) {
    return { value: 'no', confidence: 'medium', source: 'name/tags/description', label: (t) => t.no };
  }
  if (/bp wipe|blueprint wipe|full wipe|вайп чертеж/.test(text)) {
    return { value: 'yes', confidence: 'low', source: 'name/tags/description', label: (t) => t.yes };
  }
  return { value: 'unknown', confidence: null, source: null, label: (t) => t.unknown };
}

function sourceLabel(server, t) {
  if (server.ownerVerified) return t.verified;
  if (server.mapSizeSource === 'a2s.rules' || server.bpWipeSource === 'a2s.rules' || server.pingMs) return t.sourceA2s;
  if (server.wipeSource === 'steam.gametype.born') return t.sourceBorn;
  if (server.wipeSource === 'server.tags' || server.tags?.length) return t.officialTag;
  if (server.wipeSource === 'name/description' || server.gatherRateDetected || server.groupLimitDetected) return t.nameDetected;
  if (server.lastWipeDetected) return t.historyEstimated;
  return t.sourceEstimate;
}

function hasStrongSource(server) {
  return Boolean(
    server.ownerVerified
    || server.mapSizeSource === 'a2s.rules'
    || server.bpWipeSource === 'a2s.rules'
    || server.wipeSource === 'steam.gametype.born'
    || (server.dataQuality || 0) >= 85
  );
}

function displayPopulation(server) {
  const max = Math.max(0, Number(server.maxPlayers) || 0);
  const raw = Math.max(0, Number(server.players) || 0);
  const active = max > 0 ? Math.min(raw, max) : raw;
  const queue = max > 0 ? Math.max(0, raw - max) : 0;
  return {
    raw,
    active,
    queue,
    max,
    ratio: percentage(active, max)
  };
}

function buildWipeBuckets(servers) {
  const ranges = [
    { key: 'under10', labelKey: 'wipeUnder10', min: 0, max: 10 },
    { key: '10to30', labelKey: 'wipe10to30', min: 10, max: 30 },
    { key: '30to60', labelKey: 'wipe30to60', min: 30, max: 60 },
    { key: 'today', labelKey: 'wipedToday', min: 60, max: 1440 }
  ];
  return ranges.map((range) => ({
    ...range,
    label: range.labelKey,
    servers: servers
      .filter((server) => {
        const age = ageMinutes(server.lastWipeDetected);
        return age !== null && age >= range.min && age < range.max;
      })
      .sort((a, b) => b.radarScore - a.radarScore)
      .slice(0, 4)
  }));
}

function parseSmartSearchInput(query) {
  const raw = String(query || '');
  const value = raw
    .toLowerCase()
    .replace(/[|,+/]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const filters = {};
  const local = {};
  let remaining = ` ${value} `;

  const has = (pattern) => pattern.test(value);
  const consume = (pattern) => {
    remaining = remaining.replace(pattern, ' ');
  };

  if (has(/\b(eu|europe|europa)\b/)) {
    filters.region = 'EU';
    consume(/\b(eu|europe|europa)\b/g);
  }
  if (has(/\b(de|ger|germany|german|deutsch|deutsche)\b/)) {
    filters.region = 'EU';
    consume(/\b(de|ger|germany|german|deutsch|deutsche)\b/g);
  }
  if (has(/\b(us|usa|america|american)\b/)) {
    filters.region = 'US';
    consume(/\b(us|usa|america|american)\b/g);
  }
  if (has(/\bna\b/)) {
    filters.region = 'NA';
    consume(/\bna\b/g);
  }
  if (has(/\b(au|australia)\b/)) {
    filters.region = 'AU';
    consume(/\b(au|australia)\b/g);
  }
  if (has(/\b(sea|asia)\b/)) {
    filters.region = 'SEA';
    consume(/\b(sea|asia)\b/g);
  }
  if (has(/\b(ru|russian|russia)\b/)) {
    filters.region = 'RU';
    consume(/\b(ru|russian|russia)\b/g);
  }

  if (has(/\bsolo\b/)) {
    filters.group = 'solo';
    consume(/\bsolo\b/g);
  }
  if (has(/\bduo\b/)) {
    filters.group = 'duo';
    consume(/\bduo\b/g);
  }
  if (has(/\btrio\b/)) {
    filters.group = 'trio';
    consume(/\btrio\b/g);
  }
  if (has(/\bquad\b/)) {
    filters.group = 'quad';
    consume(/\bquad\b/g);
  }
  if (has(/\b(max\s*5|5\s*max|max5)\b/)) {
    filters.group = '5-max';
    consume(/\b(max\s*5|5\s*max|max5)\b/g);
  }
  if (has(/\b(max\s*6|6\s*max|max6)\b/)) {
    filters.group = '6-max';
    consume(/\b(max\s*6|6\s*max|max6)\b/g);
  }
  if (has(/\b(no\s*limit|nolimit|unlimited|clan|zerg)\b/)) {
    filters.group = 'no-limit';
    consume(/\b(no\s*limit|nolimit|unlimited|clan|zerg)\b/g);
  }

  const rate = value.match(/\b(1\.5|1,5|2|3|5|10|50|100)\s*x\b/);
  if (rate) {
    filters.gather = `${rate[1].replace(',', '.')}x`;
    consume(/\b(1\.5|1,5|2|3|5|10|50|100)\s*x\b/g);
  }

  if (has(/\bvanilla\+?\b/)) {
    filters.mode = 'vanilla';
    consume(/\bvanilla\+?\b/g);
  }
  if (has(/\b(modded|oxide|carbon|kits|kit|tp|teleport|shop|custom|boosted)\b/)) {
    filters.mode = 'modded';
    consume(/\b(modded|oxide|carbon|kits|kit|tp|teleport|shop|custom|boosted)\b/g);
  }
  if (has(/\bpve\b|\bzombies?\b/)) {
    filters.mode = 'pve';
    consume(/\bpve\b|\bzombies?\b/g);
  }
  if (has(/\b(official|facepunch)\b/)) {
    filters.mode = 'official';
    consume(/\b(official|facepunch)\b/g);
  }

  if (has(/\bbi\s*weekly\b|\bbiweekly\b|\bbi-weekly\b/)) {
    filters.wipe = 'biweekly';
    consume(/\bbi\s*weekly\b|\bbiweekly\b|\bbi-weekly\b/g);
  } else if (has(/\bweekly\b/)) {
    filters.wipe = 'weekly';
    consume(/\bweekly\b/g);
  }
  if (has(/\bmonthly\b/)) {
    filters.wipe = 'monthly';
    consume(/\bmonthly\b/g);
  }
  if (has(/\bdaily\b/)) {
    filters.wipe = 'daily';
    consume(/\bdaily\b/g);
  }
  if (has(/\b(just|fresh|new)\s+(wipe|wiped)\b|\b(wipe|wiped)\s+(today|now|just)\b|\bjustwiped\b|\bfreshwipe\b|\bgerade\s+gewiped\b/)) {
    filters.sort = 'wipe';
    local.justWiped = true;
    consume(/\b(just|fresh|new)\s+(wipe|wiped)\b|\b(wipe|wiped)\s+(today|now|just)\b|\bjustwiped\b|\bfreshwipe\b|\bgerade\s+gewiped\b/g);
  }

  if (has(/\b(no\s*bp|nobp|no\s*blueprint|no\s*bps|kein\s*bp|ohne\s*bp)\b/)) {
    filters.bp = 'no';
    consume(/\b(no\s*bp|nobp|no\s*blueprint|no\s*bps|kein\s*bp|ohne\s*bp)\b/g);
  }
  if (has(/\b(high\s*pop|highpop|active|full|voll)\b/)) {
    filters.population = 'high';
    consume(/\b(high\s*pop|highpop|active|full|voll)\b/g);
  }
  if (has(/\b(low\s*pop|lowpop|empty|leer|quiet|ruhig)\b/)) {
    filters.population = 'low';
    consume(/\b(low\s*pop|lowpop|empty|leer|quiet|ruhig)\b/g);
  }
  if (has(/\b(low\s*ping|lowping|ping)\b/)) {
    filters.lowPing = true;
    consume(/\b(low\s*ping|lowping)\b/g);
  }

  const pingLimit = value.match(/\bping\s*(?:under|unter|below|<)?\s*(\d{2,3})\b|\b(?:under|unter|below|<)\s*(\d{2,3})\s*ping\b/);
  if (pingLimit) {
    filters.lowPing = true;
    filters.pingMax = pingLimit[1] || pingLimit[2];
    consume(/\bping\s*(?:under|unter|below|<)?\s*\d{2,3}\b|\b(?:under|unter|below|<)\s*\d{2,3}\s*ping\b/g);
  }

  const playerMinimum = value.match(/\b(\d{2,4})\s*\+?\s*(players?|pop|spieler)\b|\b(players?|pop|spieler)\s*(?:over|above|ab|>|mindestens)?\s*(\d{2,4})\b/);
  if (playerMinimum) {
    filters.playersMin = playerMinimum[1] || playerMinimum[3];
    consume(/\b\d{2,4}\s*\+?\s*(players?|pop|spieler)\b|\b(players?|pop|spieler)\s*(?:over|above|ab|>|mindestens)?\s*\d{2,4}\b/g);
  }

  const textQuery = remaining
    .replace(/\b(and|with|server|servers|rust|find|suche|mit|und)\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return { filters, local, query: textQuery };
}

function optionLabel(value, t) {
  const map = {
    all: t.all,
    vanilla: t.vanilla,
    modded: t.modded,
    official: t.official,
    pve: t.pve,
    players: t.players,
    fresh: t.updatedAgo,
    confidence: t.confidence,
    radar: t.ranking,
    verified: t.strongData,
    high: t.highPop,
    medium: 'Medium',
    low: 'Low',
    no: t.no,
    yes: t.yes,
    unknown: t.unknown
  };
  return map[value] || value;
}

function formatRelative(value, t) {
  if (!value) return t.unknown;
  const diff = Date.now() - new Date(value).getTime();
  if (diff < -5 * 60000) return t.unknown;
  if (diff < 0) return '0 min';
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  if (days === 1) return t.today;
  return `${days} d`;
}

function formatRelativePast(value, t) {
  if (!value) return t.unknown;
  const diff = Date.now() - new Date(value).getTime();
  const seconds = Math.max(0, Math.floor(diff / 1000));
  if (seconds < 60) return `${seconds} s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  return `${Math.floor(hours / 24)} d`;
}

function formatDate(value, withYear = false) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: withYear ? '2-digit' : undefined,
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

function percentage(players, maxPlayers) {
  if (!maxPlayers) return 0;
  return Math.max(0, Math.min(100, Math.round(((players || 0) / maxPlayers) * 100)));
}

function formatNumber(value) {
  return new Intl.NumberFormat('de-DE').format(value || 0);
}

function dateValue(value) {
  return value ? new Date(value).getTime() || 0 : 0;
}

function readJson(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
}

function detectLanguage() {
  const code = navigator.language?.slice(0, 2).toLowerCase();
  return LANGS.includes(code) ? code : 'de';
}

export default App;
